// Minimal i18n: dictionary + simple t() with localStorage persistence
import { createContext, useContext, useState } from "react";

const DICT = {
  nl: {
    // Header
    nav_create: "Maken", free_remaining: "gratis over", unlocked: "Pro actief",
    free_daily_intro: "Gratis: 1 bingo per dag —", free_daily_cards_left: "kaarten over vandaag", free_daily_used: "Je gratis bingo van vandaag is gebruikt.", free_next_in: "weer gratis over ±", hours_short: "u",
    pw_daily_title: "Je gratis bingo van vandaag is op", pw_daily_body: "Je maakt gratis 1 bingo (tot 20 kaarten) per 24 uur. Upgrade nu voor onbeperkt, of kom straks terug —",
    // Hero — SEO-optimized (2026-08-16): H1 targets "Bingokaarten Generator"
    // per GSC data (homepage: 1047 impressions on this cluster).
    hero_badge: "20 Kaarten gratis · 15 thema's",
    hero_h1_main: "bingocards-generator",
    hero_h1_sub: "De complete online bingo generator.",
    hero_subtitle_new: "Bingokaarten generator met AI, muziekbingo, live caller & PDF. Voor scholen, feestjes en bedrijven — print gratis of speel online, geen account nodig.",
    hero_promise_h1: "Organiseer in 5 minuten een complete bingo",
    hero_promise_sub: "Maak gratis je bingokaarten, deel ze met je spelers en speel direct online mee.",
    hero_cta_primary: "Maak gratis je bingo",
    hero_cta_secondary: "Bekijk hoe het werkt",
    hero_trust: "Geen creditcard · geen account · gratis beginnen",
    hero_benefit_1: "In minuten klaar",
    hero_benefit_2: "Print of speel online",
    hero_benefit_3: "Voor elke gelegenheid",
    trust_fact_1: "Geen account nodig",
    trust_fact_2: "20 kaarten gratis",
    trust_fact_3: "Print of speel online",
    trust_fact_4: "NL · EN · DE",
    // ── FASE C: generator quick-start + "bingo klaar" success moment ──
    qs_title: "Snelstart in 3 stappen",
    qs_dismiss: "Overslaan",
    qs_step1: "Kies je bingo",
    qs_step2: "Voor hoeveel spelers?",
    qs_step3: "Maak je bingo",
    qs_type_words: "Woordbingo", qs_type_words_desc: "Eigen woorden of thema",
    qs_type_music: "Muziekbingo", qs_type_music_desc: "Speelt in de app",
    qs_type_numbers: "Nummerbingo", qs_type_numbers_desc: "Klassiek 1–75 of 1–90",
    qs_type_ai: "Laat AI het doen", qs_type_ai_desc: "Beschrijf je thema",
    qs_players_hint: "Meestal 1 kaart per speler — je kunt dit later aanpassen.",
    qs_players_custom: "Anders",
    qs_players_unit: "spelers",
    qs_next: "Volgende", qs_back: "Terug",
    qs_make: "Maak mijn bingo",
    qs_fill_words: "Vul hieronder je woorden in (of gebruik een thema), dan maak je de kaarten.",
    ready_title: "Je bingo is klaar!",
    ready_subtitle: "kaarten klaar om te printen of online te spelen.",
    ready_download: "Download PDF", ready_download_desc: "Print thuis of op school",
    ready_online: "Online spelen", ready_online_desc: "Deel via QR-code",
    ready_caller: "Live caller", ready_caller_desc: "Presenteer op beamer of digibord",
    ready_upgrade_line: "Online spelen & live caller zitten in PRO — vanaf €9,95 per sessie.",
    ready_upgrade_cta: "Bekijk PRO",
    ready_locked: "PRO",
    // ── FASE D: eerlijke betaal-trust + use-cases (geen verzonnen reviews) ──
    pay_trust_1: "Eenmalig betalen, geen abonnement",
    pay_trust_2: "Veilig betalen via iDEAL & Stripe",
    pay_trust_3: "Geen account nodig",
    pay_trust_4: "20 kaarten gratis om te proberen",
    hero_spotify_badge: "Muziek speelt in de app",
    usecases_badge: "Voor elke gelegenheid",
    usecases_h: "Waarvoor gebruiken mensen bingocards-generator?",
    usecases_p: "Van klaslokaal tot kroeg — dezelfde generator, eindeloos veel gelegenheden.",
    uc_school_h: "Scholen & klaslokaal", uc_school_p: "Reken-, spelling- of ESL-bingo voor de hele klas, klaar voordat de bel gaat.",
    uc_party_h: "Kinderfeestjes", uc_party_p: "Thema-bingo met eigen foto's en woorden — hét ijsbrekertje op elk feestje.",
    uc_office_h: "Bedrijven & teambuilding", uc_office_p: "Kennismakings- en vergaderbingo voor teamuitjes en personeelsfeesten.",
    uc_wedding_h: "Bruiloften", uc_wedding_p: "Persoonlijke bingo met herinneringen aan het bruidspaar voor de gasten.",
    uc_music_h: "Muziekavonden", uc_music_p: "Muziekbingo die direct in de app speelt — foute kerst, jaren 80/90 en meer.",
    uc_care_h: "Zorg & ouderen", uc_care_p: "Grote, goed leesbare kaarten met getallen of woorden voor activiteiten.",
    // 4 Hero tiles (GEO Stap 1)
    tile_ai_h: "AI thema-generator", tile_ai_p: "Elk onderwerp — kant-en-klare kaarten in 15 seconden.",
    tile_music_h: "Muziek bingo", tile_music_p: "14 genres · speelt in de app · foute kerst, bruiloft, jaren 80/90.",
    tile_live_h: "Live caller", tile_live_p: "Presenteer op beamer of digibord met scoreboard.",
    tile_print_h: "PDF & online spelen", tile_print_p: "Print thuis of speel via QR-code op de telefoon.",
    tile_cta: "Openen",
    nav_compare: "Vergelijking",
    footer_compare: "Vergelijking 2026",
    nav_which_today: "Welke bingo wil je maken?",
    nav_group_popular: "Populair",
    nav_group_tools: "Handige tools",
    nav_group_info: "Info",
    // 6 clear bingo paths (dropdown + Landing choice grid)
    menu_music_spotify: "Muziekbingo met muziek",
    menu_music_spotify_sub: "Nummers spelen direct in de app",
    menu_music_only: "Muziekbingo — alleen kaarten",
    menu_music_only_sub: "14 genres, print of speel online",
    menu_number_bingo: "Nummerbingo 75 / 90",
    menu_number_bingo_sub: "Kant-en-klare nummerkaarten (1-75 & 1-90)",
    menu_ball_drawer: "Bingo ballen trekker",
    menu_ball_drawer_sub: "Online caller — trekt automatisch de ballen",
    menu_theme_bingo: "Thema bingo",
    menu_theme_bingo_sub: "Kerst, verjaardag, bruiloft, kinderfeestje",
    menu_sinterklaas: "Sinterklaasbingo",
    menu_sinterklaas_sub: "Plaatjesbingo & muziekbingo — kant-en-klaar",
    menu_ai_bingo: "AI-gegenereerde bingo",
    menu_ai_bingo_sub: "Beschrijf je feest — AI maakt de rest",
    menu_custom_bingo: "Eigen bingo",
    menu_custom_bingo_sub: "Zelf woorden of foto's uploaden",
    landing_choose_h: "Welke bingo wil je maken?",
    landing_choose_p: "Kies je type — in 30 seconden aan het spelen. Print gratis of speel online.",
    hero_title_a: "Maak", hero_title_b: "bingokaarten", hero_title_c: "die", hero_title_d: "echt", hero_title_e: "leuk zijn.",
    hero_subtitle: "Een kant-en-klare bingo generator voor leraren, ouders & bingo-presentatoren. Tekst of plaatjes, klassiek of bulk. Geen account nodig.",
    cta_start: "Start nu gratis", cta_bulk: "Bulk generator", no_card_needed: "Geen creditcard. Geen account. Direct beginnen.",
    // Features
    features_title: "Eén tool. Alle bingo's. Geen gedoe.",
    features_subtitle: "bingocards-generator is volledig AI based, met scherpe typografie, 15 kant-en-klare thema's, een unieke presentator weergave, unieke deel-codes en auto kaart-toewijzing.",
    f1_title: "3x3, 4x4, 5x5", f1_desc: "Alle formaten. Klassieke 5x5 met FREE in het midden of compacter voor kids.",
    f2_title: "Tekst of plaatjes", f2_desc: "Upload eigen afbeeldingen of tik tekst. Perfect voor thema-feestjes & lesactiviteiten.",
    f3_title: "15 thema's", f3_desc: "Sinterklaas, Kerst, Muziek, Pasen, Halloween, Bruiloft en meer — kant-en-klaar.",
    f4_title: "PDF & Delen", f4_desc: "Print perfect en deel via één link — elke speler krijgt automatisch een eigen kaart.",
    themes_title: "15 kant-en-klare thema's", view_all: "Bekijk alle",
    how_works: "Zo werkt het", how_intro: "Van idee naar print<br/>in drie stappen.",
    how1_t: "Kies thema", how1_d: "Klik op één van de 15 thema's of begin blanco.",
    how2_t: "Vul in", how2_d: "Tik teksten, upload plaatjes, of laat het thema auto-vullen.",
    how3_t: "Print of deel", how3_d: "Download PDF, of deel één link en laat elke speler een eigen kaart krijgen.",
    // Pricing
    prices: "Prijzen",
    pricing_title: "20 kaarten gratis. vanaf €9,95 per sessie.",
    pricing_subtitle: "Eenmalige betaling per sessie. Branding, presentator modus en deel-codes alleen tijdens betaalde sessies. iDEAL & kaart.",
    free_plan: "Gratis", paid_plan: "Pro sessie", per_session: "per sessie · eenmalig per sessie van 20+ kaarten",
    always: "Altijd", popular: "Populair", try_no_account: "Probeer alles uit, zonder account.",
    free_f1: "1 gratis bingo per dag (tot 20 kaarten)", free_f2: "Alle 15 thema's & formaten", free_f3: "PDF download", free_f4: "Tekst & plaatjes uploaden",
    locked_f1: "Eigen logo & bedrijfsnaam", locked_f2: "Presentator modus (nummers trekken)", locked_f3: "Online delen met deel-code", locked_f4: "Auto kaart-toewijzing per speler",
    pro_f1: "Onbeperkt kaarten in deze sessie", pro_f2: "Alle thema's, formaten, PDF",
    pro_f3: "Eigen logo & bedrijfsnaam", pro_f4: "Presentator modus (nummers + bingo check)",
    pro_f5: "Online deel-code", pro_f6: "Auto kaart-toewijzing — 1 link, 100 spelers, allemaal verschillend",
    pro_f7: "Aangepast FREE-woord op kaart", pro_f8: "Live scorebord met 'bijna bingo' meldingen",
    pro_f_music1: "Muziekbingo-presenteermodus: elk nummer speelt af met grote albumhoes op groot scherm",
    pro_f_music2: "Raad-modus + QR-scherm zodat spelers direct meespelen",
    cta_make_first: "Maak je eerste kaart",
    // Builder
    builder_title: "Bingo maker", one_card: "Eén kaart", bulk_gen: "Bulk generator",
    generator: "Generator",
    items: "items", ready: "klaar", more_needed: "te weinig",
    need_minimum: "Minimaal", items_for_size: "items vereist voor formaat", currently_have: "Je hebt nu",
    min_items_explainer: "Vereist aantal voor formaat",
    your_card: "JOUW KAART",
    add_items_first: "Voeg eerst items toe.",
    you_are: "Je speelt als", change: "wijzig",
    name_explainer: "Vul je naam in om mee te spelen. Anderen zien je hier zodra je gaat winnen!",
    live_status: "Live status",
    // Post-save modal
    psm_title: "Je hebt de bingokaarten gemaakt … en nu?",
    psm_subtitle: "Volg dit stappenplan en in 3 minuten speelt iedereen mee.",
    psm_step: "Stap",
    psm_your_task: "Jouw taak",
    psm_step1_title: "Deel de bingokaarten met je deelnemers",
    psm_step1_task: "Genereer een QR code en laat deze zien",
    psm_qr_label: "QR code — scan & speel",
    psm_qr_explainer: "Print of toon deze QR code zodat deelnemers met hun telefoon direct hun eigen kaart krijgen. Ook handig om in de uitnodiging te plakken.",
    psm_qr_download: "Download QR code",
    psm_code_label: "Deel-code & link",
    psm_code_explainer: "Plak deze code of link in je uitnodigings-mail, WhatsApp of agenda. Iedereen die de link opent krijgt automatisch een unieke kaart.",
    psm_step2_title: "Iedere deelnemer krijgt een unieke kaart",
    psm_step2_explainer: "Wanneer een deelnemer voor het eerst de link opent, wordt automatisch één van de gegenereerde kaarten toegewezen. Bij latere bezoeken zien ze altijd dezelfde kaart — geen verwarring.",
    psm_step3_title: "Druk op 'Presenteer' om host te worden",
    psm_step3_explainer: "Als jij de bingo-host bent, opent het presentatorscherm. Daar bepaal je per ronde het bingo-patroon, zie je live alle deelnemers, controleer je bingo-claims en bekijk je de kaarten in één oogopslag.",
    psm_have_fun: "Veel bingoplezier!",
    psm_help: "Lukt iets niet?",
    psm_protip_label: "Pro tip",
    psm_copy_invite: "Kopieer uitnodiging (WhatsApp)",
    psm_invite_copied: "Uitnodiging gekopieerd! Plak in WhatsApp of mail.",
    psm_invite_template: "🎉 Bingo-time! Doe je mee?\n\nDoor op de link te drukken ontvang je een eigen unieke kaart — gewoon openen op je telefoon.\nVergeet je naam niet in te vullen!\n\n👉 Speel mee: {url}\n\nTot zo!",
    psm_reopen: "Uitleg opnieuw bekijken",
    edit_applied: "Wijziging opgeslagen op dezelfde code",
    edits_left_suffix: "edit over",
    session_consumed: "Sessie verbruikt. Een nieuwe set kost €9,95.",
    edit_quota_exceeded: "Je hebt al een keer aangepast. Voor verdere wijzigingen: nieuwe sessie.",
    settings: "Kaart instellingen", title_label: "Titel", size_label: "Formaat", free_middle: "FREE midden",
    free_word: "FREE woord", theme: "Thema", branding: "Branding (Pro)", brand_name_label: "Bedrijfsnaam (sub-titel)",
    logo_label: "Logo (PNG/JPG, max 1MB)", logo_size_label: "Logo grootte", upload: "Upload", replace: "Vervang", optional: "Optioneel",
    actions: "Acties", shuffle: "Husselen", clear: "Leegmaken", download_pdf: "Download PDF",
    cards_per_page: "Kaarten per pagina",
    bulk_settings: "Bulk instellingen", num_cards: "Aantal kaarten", items_list: "Items lijst (1 per regel)",
    images_opt: "Plaatjes (optioneel)", generate: "Genereer", download: "Download",
    share_title: "Online delen & presenteren (Pro)", share_desc: "Sla je kaarten online op met deel-code. Elke speler die de link opent krijgt automatisch een andere kaart toegewezen.",
    save_get_code: "Spelen en presenteren!", your_code: "Jouw deel-code", copy_link: "Kopieer link",
    view: "Bekijk", present: "Presenteer", pro_only_lock: "Pro-functie",
    editor: "Editor", print_preview: "Print voorbeeld", preview: "Voorbeeld", no_cards_yet: "Nog geen kaarten.", fill_and_click: "Vul je lijst in en klik",
    preview_one_of: "kaart 1 van",
    preview_one_of_x: "kaart {n} van {total}",
    preview_pdf_match: "Dit is exact hoe je PDF eruit gaat zien — 1-op-1.",
    pick_card: "Kies kaart",
    card: "Kaart",
    reshuffle_btn: "Nieuwe ronde, nieuwe kaarten",
    reshuffle_hint: "Hergenereer alle kaarten met willekeurige posities — zelfde itemlijst",
    reshuffled_toast: "Nieuwe kaarten gegenereerd!",
    cell_help: "Klik in een cel om tekst toe te voegen. Gebruik het 📷 icoon om een plaatje te uploaden.",
    pro_only_panel: "Beschikbaar tijdens een Pro-sessie (€9,95).", pro_active: "Pro actief", unlock_pro: "Ontgrendel Pro",
    fill_with: "Vul met", content: "content", busy: "Bezig…",
    fill_with_short: "Vul thema",
    themes_show: "Andere thema's", themes_hide: "Verbergen",
    cross_examples_h: "Bekijk 9 AI bingo voorbeelden",
    cross_examples_p: "Verjaardag, bruiloft, klasbingo, kantoor, vrijgezellenfeest en meer. Eén klik om de items te laden in de generator.",
    cross_examples_cta: "Voorbeelden gallerij",
    cross_caller_badge: "Bingo Caller",
    cross_caller_h: "Online bingo getallen trekken",
    cross_caller_p: "Gratis bingo caller voor 1-75 of 1-90. Werkt direct in je browser. Ook embedbaar op je eigen site.",
    cross_caller_cta: "Open bingo caller",
    // Play
    play_assigned: "Je hebt automatisch", play_card: "kaart", play_total: "kaarten totaal",
    your_name: "Jouw naam (voor presentator)", call_bingo: "Roep BINGO!", sending: "Versturen…",
    valid_bingo: "Geverifieerd: jouw kaart heeft een geldige bingo lijn.", invalid_bingo: "Nog geen geldige bingo lijn op dit moment.",
    claimed_at: "Geclaimd om", presenter_sees: "De presentator ziet je in het scorebord.",
    // Host
    host_locked_title: "Presentator modus is Pro",
    host_locked_desc: "Ontgrendel met een Pro-sessie (€9,95) om nummers te trekken, bingo's te controleren en spelers live te zien claimen.",
    unlock_session: "🎟️ Ontgrendel deze sessie", or_view_player: "Of bekijk een kaart als speler",
    last_draw: "Laatste trekking", click_draw_to_start: "Klik op",
    draw_next: "Trek volgende", drawing: "Trekken…", reset: "Reset",
    all_drawn_items: "Alle items", presenter: "PRESENTATOR · CODE",
    cards: "kaarten", claims: "claims", drawn: "getrokken",
    view_player_view: "Bekijk speler-view",
    scoreboard: "Live scorebord", bingo_claims: "🎉 Bingo claims",
    no_claims_yet: "Nog geen claims. Spelers krijgen een", almost_bingo: "🔥 Bijna bingo",
    away: "nog", to_go: "nodig",
    new_claims: "Nieuwe claims", show: "Toon", accept: "Accept", reject: "Reject",
    winners: "Winnaars",
    check_card_title: "Controleer kaart",
    bingo: "BINGO", no_bingo: "Geen bingo", full_house: "Volle kaart", marked_count: "vakken",
    fill_card_num: "Vul een kaartnummer in.",
    // Payment
    payment_success_title: "Betaling gelukt!", payment_success_desc: "Je account is ontgrendeld. Maak nu onbeperkt bingokaarten.",
    back_to_builder: "Verder maken",
    payment_polling: "Betaling controleren…", payment_unknown: "Status onbekend",
    payment_unknown_desc: "We konden je betaling nog niet bevestigen. Check later of probeer opnieuw.",
    back_to_maker: "Terug naar maker",
    payment_cancelled: "Betaling geannuleerd", payment_cancelled_desc: "Geen probleem — je kunt later opnieuw proberen wanneer je klaar bent.",
    // Paywall
    pw_golden: "Gouden ticket", pw_unlock_all: "Ontgrendel alles",
    pw_intro: "Je hebt je", pw_intro_2: "gratis kaarten gebruikt.", pw_intro_3: "Kies je pakket en print meteen meer kaarten.",
    pw_intro_more: "Ontgrendel Pro om onbeperkt kaarten te maken, printen en delen.",
    proplus_cta_builder: "Muziekbingo? Exporteer naar Spotify (Pro+)",
    gate_title: "Nog één stap",
    gate_body: "Vul je e-mailadres in — we bewaren je bingo en sturen je een link om 'm te bekijken, te printen en later aan te passen.",
    gate_confirm: "Opslaan & doorgaan",
    gate_skip: "Doorgaan zonder opslaan",
    sp_connected_ok: "Spotify gekoppeld! Je kunt nu je playlist maken.",
    sp_connect_err: "Koppelen met Spotify lukte niet. Probeer het opnieuw of log opnieuw in.",
    proplus_connect_h: "Nog één stap: verbind met Spotify",
    proplus_connect_p: "Koppel je Spotify-account, dan kun je meteen een afspeelbare playlist maken en presenteren.",
    stepper_done: "Klaar",
    step_create: "Maken", step_create_sub: "Vul in & genereer",
    step_pro: "Pro", step_pro_sub: "Ontgrendel alles",
    step_save: "Opslaan", step_save_sub: "Bewaar & mail link",
    step_proplus: "Pro+", step_proplus_sub: "Spotify-upgrade",
    step_spotify: "Spotify", step_spotify_sub: "Account koppelen",
    step_present: "Presenteren", step_present_sub: "Start de bingo",
    save_first_to_present: "Sla je bingo eerst op, dan kun je presenteren.",
    menu_title: "Wat wil je doen?",
    menu_call_sheet: "Presenteer verzamelsheet",
    menu_play_present: "Spelen & presenteren",
    menu_activate_spotify: "Activeer Spotify-integratie",
    menu_activate_note: "Eenmalig €4,99 — ontgrendelt echte Spotify-playlists.",
    menu_generate_first: "Genereer eerst je kaarten.",
    menu_call_sheet_help: "Alle woorden/liedjes om voor te lezen.",
    menu_download_help: "Liedjeslijst als bestand opslaan.",
    menu_demo_btn: "Proef de muziekbingo (gratis)",
    menu_demo_help: "Beluister de eerste 10 nummers met albumhoes — zo klinkt je bingo.",
    missing_clips_title: "Niet alle nummers gevonden",
    missing_clips_desc: "Van deze nummers konden we geen fragment of albumhoes vinden:",
    missing_clips_hint: "Tip: pas de artiest/titel iets aan in je nummerlijst, of vervang ze tijdens het presenteren via 'Zoek een fragment'.",
    missing_clips_ok: "Begrepen",
    bs_start_title: "De muziekbingo gaat zo beginnen!",
    bs_start_scan: "Scan de QR-code om mee te spelen",
    bs_joined_label: "spelers klaar om mee te doen",
    bs_joined_one: "speler klaar om mee te doen",
    menu_spotify_help: "Bonus: exporteer je nummers naar een Spotify-playlist.",
    menu_play_help: "Speel de muziek direct in de app af en presenteer op groot scherm.",
    menu_activate_spotify_short: "Activeer Spotify",
    cs_title: "Verzamelsheet",
    cs_items: "items",
    cs_tab_list: "Lijst",
    cs_tab_caller: "Caller-modus",
    cs_copy: "Kopieer alle items",
    cs_copied: "Gekopieerd",
    cs_copy_toast: "Alle items gekopieerd naar klembord",
    cs_copy_fail: "Kopiëren mislukt — probeer handmatig te selecteren",
    cs_board: "Digibord",
    cs_board_title: "Volledig scherm (voor digibord)",
    cs_fs_unsupported: "Volledig scherm niet ondersteund",
    cs_print: "Print",
    cs_close: "Sluiten",
    cs_list_desc_a: "Deze items staan in willekeurige volgorde — perfect om af te lezen tijdens de bingo. Klik",
    cs_list_desc_b: " om ze te plakken in Word, PowerPoint of je digibord-app.",
    cs_current: "Huidige oproep",
    cs_ready: "Klaar om te beginnen",
    cs_of: "van",
    cs_called: "opgeroepen",
    cs_togo: "te gaan",
    cs_all_called: "Alle items opgeroepen",
    cs_start: "Start (Spatie)",
    cs_next: "Volgende (Spatie)",
    cs_reset: "Opnieuw",
    cs_recent: "Recent opgeroepen",
    cs_tip: "Tip: klik 'Digibord' voor volledig scherm op je smart board. In Caller-modus druk je op de spatiebalk voor het volgende item.",
    proplus_connect_btn: "Verbind met Spotify",
    pw_b1: "Onbeperkt kaarten in deze sessie", pw_b2: "Branding (logo + bedrijfsnaam)",
    pw_b3: "Presentator modus + scorebord", pw_b4: "Eigen plaatjes & thema's",
    pw_pay: "Betaal met iDEAL / Kaart", pw_later: "Misschien later",
    restore_cta: "Al betaald? Herstel je aankoop",
    restore_email_label: "E-mailadres waarmee je betaalde",
    restore_email_ph: "jij@voorbeeld.nl",
    restore_btn: "Herstel",
    restore_hint: "We koppelen je eerdere betaling aan dit apparaat.",
    restore_ok: "Aankoop hersteld! Je Pro-toegang staat weer actief op dit apparaat.",
    restore_none: "Geen betaalde aankoop gevonden voor dit e-mailadres.",
    restore_invalid: "Vul een geldig e-mailadres in.",
    restore_fail: "Herstellen mislukt. Probeer het later opnieuw.",
    ps_paid_h: "Betaling gelukt!",
    ps_paid_p: "Je account is ontgrendeld. Maak nu onbeperkt bingokaarten.",
    ps_continue: "Verder maken",
    ps_checking_h: "Betaling controleren…",
    ps_checking_p: "Even geduld, we bevestigen je betaling.",
    ps_unknown_h: "Status onbekend",
    ps_unknown_p: "We konden je betaling nog niet bevestigen. Check later of probeer opnieuw.",
    ps_back: "Terug naar maker",
    upsell_h: "Ga je een muziekbingo maken?",
    upsell_p: "Wil je Spotify integreren zodat de muziek meteen kan worden afgespeeld tijdens het spel?",
    upsell_note: "*Vereist een Spotify Premium-account.",
    upsell_btn: "Ja, voeg Spotify toe (+€4,99)",
    from_price: "vanaf", tier_upto: "Tot", tier_cards: "kaarten", tier_unlimited: "Onbeperkt kaarten",
    tier_per_session: "Eenmalig per sessie", tier_popular: "Meest gekozen", tier_you_pay: "Jij betaalt",
    pw_secure: "Veilige betaling via Stripe. iDEAL, creditcard, en meer.",
    eenmalig: "eenmalig",
    // Builder extras
    on: "AAN", off: "UIT", default_title: "Mijn Bingo", optional_placeholder: "Optioneel",
    save_failed: "Opslaan mislukt.", saved_code: "Opgeslagen! Code:", link_copied: "Link gekopieerd!",
    cells_first: "Vul eerst wat cellen in.", choose_theme_first: "Kies eerst een thema met content.",
    loaded: "ingeladen!",
    number_bingo: "Nummer-bingo", number_bingo_desc: "Klassieke bingo met getallen 1–75 of 1–90 (zonder thema). 5x5 grid met FREE.",
    generate_n_cards: "Genereer", num_to: "1 t/m", make_or_generate_first: "Maak of genereer eerst kaarten.",
    free_left_msg: "Je hebt nog", free_left_left: "gratis kaarten over.", numbers_generated: "nummer-bingo kaarten (1-",
    cards_generated: "kaarten gegenereerd!", pro_test_active: "Pro test actief", pro_deactivate: "Deactiveer",
    pro_deactivate_confirm: "Pro deactiveren? Je krijgt een nieuwe client-id met 20 gratis kaarten.",
    confirm_click_again: "Klik nogmaals",
    activate_pro_test: "🧪 Activeer Pro test", pro_test_activated: "🧪 Pro test-sessie geactiveerd — alle features ontgrendeld!",
    pro_test_failed: "Kon test-sessie niet activeren.",
    pdf_failed: "PDF maken mislukt.", generate_first: "Genereer eerst de kaarten.",
    cards_count: "kaarten", pdf_downloaded: "kaarten gedownload!",
    // Landing extras
    pro_highlight_title: "Pro maakt het écht groots",
    pro_highlight_subtitle: "Eenmalig €9,95 per sessie. Alle features los, voor je hele evenement.",
    pro_cta: "Activeer Pro",
    view_demo: "Bekijk demo scorebord",
    // Host extras
    next_round: "Volgende ronde", next_round_confirm: "Volgende ronde starten? Patroon kun je daarna kiezen. Getrokken items blijven behouden.",
    next_round_hint: "Open de nieuwe ronde opties: patroon kiezen en kaarten her-shufflen",
    next_round_title: "Volgende ronde starten",
    next_round_desc: "Kies een patroon en optioneel shuffle de kaarten. Spelers krijgen direct de nieuwe ronde te zien.",
    nr_reshuffle_label: "Kaarten her-shufflen",
    nr_reshuffle_hint: "Bouwt nieuwe kaarten uit dezelfde itemlijst — elke speler krijgt automatisch een andere kaart.",
    nr_pattern_label: "Patroon voor deze ronde",
    nr_pattern_hint: "Wijzigt het te behalen patroon — spelers zien dit direct.",
    nr_reset_note: "Getrokken items en patroon-claims worden gereset bij elke nieuwe ronde.",
    nr_start_btn: "Start nieuwe ronde",
    cards_reshuffled: "kaarten her-geshuffeld",
    cancel: "Annuleer",
    round_started: "Ronde", round_label: "RONDE", round_n_started_suffix: "gestart",
    next_round_failed: "Volgende ronde mislukt.",
    pattern_updated: "Patroon bijgewerkt", pattern_update_failed: "Patroon update mislukt.",
    all_items_drawn: "Alle items zijn al getrokken!", draw_failed: "Trekken mislukt.",
    reset_confirm: "Alle trekkingen resetten?", reset_done: "Reset!", reset_failed: "Reset mislukt.",
    enter_valid_card_num: "Vul een geldig kaartnummer in.", not_found: "Niet gevonden", update_failed: "Update mislukt.",
    oops: "Oeps", to_home: "Naar home", loading_dots: "Laden…",
    player_view: "Speler-view", bingo_pattern: "Bingo-patroon", refresh: "Ververs",
    players_count: "spelers", card_short: "Kaart", marked_short: "aangevinkt",
    valid_bingo_short: "✓ Geldige bingo", not_yet_valid: "nog niet geldig",
    devtools_visible: "🛠️ Dev tools zichtbaar", devtools_hidden: "🔒 Dev tools verborgen",
    pro_test_activated_short: "Pro test geactiveerd", activate_failed: "Activeren mislukt",
    // Music Bingo
    mb_badge: "Muziekbingo",
    mb_title_a: "Kies je",
    mb_title_b: "muziekgenre.",
    mb_subtitle: "Selecteer een genre — wij vullen automatisch 75+ hits in op je kaarten met artiest en titel.",
    mb_songs: "nummers",
    mb_create_cta: "Maak kaarten",
    mb_skip_link: "Of kies handmatig op de generator",
    nav_music_bingo: "Muziek bingo",
    nav_themes: "Thema's",
    nav_number_gen: "Ballen trekker",
    nav_teachers: "Voor leraren",
    music_sub_hub: "Alle muziek bingo",
    music_sub_foute_kerst: "Foute kerst hits",
    music_sub_foute_bedrijf: "Foute bedrijfsfeest",
    music_sub_foute_bruiloft: "Foute bruiloft",
    music_sub_nederlandstalig: "Nederlandstalige hits",
    genre_locked_title: "Geselecteerd muziekgenre",
    genre_locked_desc: "Je nummers zijn al ingeladen. Klik op 'Genereer' om je kaarten te maken.",
    change_genre: "Ander genre kiezen",
    related_genres: "Andere foute genres · verwante muziek",
    pro_only_label: "Pro",
    upgrade_to_pro_cta: "Upgrade naar Pro",
    playlist_dl_short: "Playlist",
    playlist_dl_btn: "Download playlist",
    playlist_dl_pro_hint: "Playlist downloaden is een PRO functie",
    playlist_dl_title: "Download je Spotify playlist",
    playlist_dl_desc: "Download de complete nummerlijst en importeer 'm in 1 klik in Spotify via een gratis converter.",
    playlist_dl_txt: "Download .txt",
    playlist_dl_csv: "Download .csv",
    playlist_dl_how_btn: "Hoe importeren in Spotify?",
    playlist_import_title: "In 4 stappen in je Spotify account",
    playlist_step1: "Download het .txt of .csv bestand hierboven (1 klik).",
    playlist_step2_a: "Open",
    playlist_or: "of",
    playlist_step2_b: "— beide gratis tools om muziek tussen platforms over te zetten.",
    playlist_step3: "Kies bij 'Bron' → 'Bestand uploaden' en sleep je gedownloade bestand erin. Kies bij 'Bestemming' → Spotify en log in.",
    playlist_step4: "Klik op 'Start overdracht'. Binnen 1–2 minuten staat je playlist in Spotify, klaar om te shuffelen tijdens de bingo!",
    playlist_tip: "Tip: TuneMyMusic doet de eerste 500 nummers gratis (ruim genoeg voor 80–100 bingo-songs).",

    // === Pro+ Spotify add-on ===
    proplus_badge: "Pro+ Add-on",

    // 3-options explainer (Free / Pro / Pro+)
    mb_3options_title: "Twee manieren om Muziekbingo te spelen",
    mb_3options_intro: "De muziek speelt direct in de app — elk getrokken nummer klinkt meteen met albumhoes. Geen Spotify, account of Premium nodig.",
    opt_free_badge: "Gratis demo",
    opt1_h: "Gratis demo",
    opt1_sub: "eerste 10 nummers",
    opt1_p: "Probeer de muziekbingo gratis: de eerste 10 nummers spelen in de app met albumhoes. Zo hoor je precies hoe jouw avond klinkt.",
    opt1_b1: "20 bingokaarten gratis om te printen",
    opt1_b2: "Eerste 10 nummers spelen af met 30s-fragment + albumhoes",
    opt1_b3: "Geen account, Spotify of installatie nodig",
    opt1_b4: "Max 20 kaarten gratis met deze optie!",
    opt2_h: "PRO Presenteer-modus",
    opt2_sub: "alle nummers · €9,95",
    opt2_p: "De complete muziekbingo-presentatie: onze tool trekt nummers, speelt elk 30s-fragment met grote albumhoes, houdt de score bij en valideert BINGO.",
    opt2_b1: "Alle nummers spelen af in de app (30s-fragment + albumhoes)",
    opt2_b2: "Presenteer-modus met groot scherm + QR-code om mee te spelen",
    opt2_b3: "Raad-modus: verberg de titel tot de onthulling",
    opt2_b4: "Live scorebord, BINGO-validatie en onbeperkt kaarten",
    opt2_b5: "Jij presenteert, spelers strepen af op hun kaart",
    opt2_b6: "Onbeperkt aantal kaarten maken in deze modus",
    opt3_h: "PRO+ Spotify-export",
    opt3_sub: "PRO versie + €4,99 extra",
    opt3_p: "Speel nummers direct af vanuit de bingo caller — beste ervaring als host.",
    opt3_b1: "Maak je eigen afspeellijst of kies een muzikaal thema",
    opt3_b2: "Gebruik de bingo caller voor het “trekken” van de nummers en speel het nummer direct af vanuit de caller",
    opt3_b3: "Online kaarten checker, rondes bepalen en patronen spelen",
    opt3_b4: "Onbeperkt aantal kaarten per sessie",
    opt3_b5: "Beste ervaring als bingo host",
    opt3_cta: "Activeer Pro+ — €4,99 extra",
    opt3_premium_note: "Bonus bovenop PRO — exporteert je nummers naar een Spotify-playlist",
    opt3_addon_note: "Bovenop Pro €9,95",
    pro_plus_total_explain: "Pro+ is een add-on bovenop Pro. Totaal eenmalig €14,94 voor de volledige Music Bingo Presenter ervaring.",
    pdf_footer_text: "Ook bingo spelen? www.bingocards-generator.com",
    mb_playlist_download_btn: "Download playlist",
    mb_howto_btn: "Hoe het werkt",

    // /music-bingo intro paragraph (first content after hero)
    mb_intro_h: "Wat is Muziekbingo?",
    mb_intro_p1: "Muziekbingo is hét feestspel waarbij spelers in plaats van getallen naar nummers en artiesten luisteren. Iedere speler krijgt een unieke kaart met 9, 16 of 25 vakjes vol artiesten + titels uit een gekozen genre — van 80's klassiekers tot foute Nederlandstalige meezingers. Wanneer een nummer wordt afgespeeld, strepen spelers het bijbehorende vakje door. De eerste met een rij of volle kaart roept BINGO!",
    mb_intro_p2: "Hieronder vind je 14 voorgevulde muziekgenres met 75+ hits per genre — direct te printen of online te spelen. De muziek speelt direct in de app (30s-fragment + albumhoes op groot scherm); gratis demo met de eerste 10 nummers, en met Pro álle nummers. Spotify-export is optioneel.",

    // Homepage Pro+ tier teaser
    proplus_landing_h: "Drie manieren om Muziekbingo te spelen",
    proplus_landing_p: "Van gratis demo tot alle nummers afspelen in de app. Spotify-export is een optionele Pro+ bonus.",
    proplus_tier1_h: "Gratis demo",
    proplus_tier1_p: "Maak je eigen playlist, zet op shuffle. Spelers strepen zelf af. Geen presentator nodig.",
    proplus_tier2_h: "PRO Presenteer-modus",
    proplus_tier2_p: "Onze bingo-tool trekt nummers, speelt het 30s-fragment met albumhoes af, houdt scores bij en valideert BINGO-claims.",
    proplus_tier3_h: "PRO+ Spotify-export",
    proplus_tier3_p: "Bonus: zet je nummers in één klik op een Spotify-playlist. Het afspelen in de app werkt al met Pro.",
    proplus_tier3_b1: "Eén klik = volgend nummer speelt af",
    proplus_tier3_b2: "Geen handmatig zoeken meer",
    proplus_tier3_b3: "Live controle (pauze, volgende, vorige)",
    proplus_recommended: "Aanbevolen",
    proplus_addon_label: "Add-on",
    proplus_addon_suffix: "bovenop Pro",

    proplus_title: "Exporteer je nummers naar Spotify",
    proplus_subtitle: "Bonus bovenop Pro: exporteer je nummers in één klik naar een Spotify-playlist. Afspelen in de app werkt al met Pro.",
    proplus_price_note: "eenmalig, bovenop Pro",
    proplus_features_h: "Wat krijg je extra?",
    proplus_feat_1: "Eén klik: al je nummers in een Spotify-playlist (afspelen in de app werkt al met Pro)",
    proplus_feat_2: "Geen handmatig zoeken meer in Spotify per trekking — jij focust op je publiek",
    proplus_feat_3: "Live-controle (pauze, volgende, vorige) direct vanuit de bingo-host pagina",
    proplus_feat_4: "Werkt op web + tablet, geen extra app nodig",
    proplus_premium_h: "Voor Spotify-export (Premium aanbevolen)",
    proplus_premium_p: "Spotify staat het programmatisch afspelen van nummers alleen toe voor",
    proplus_checkbox_label: "Ik begrijp dat Pro+ de Spotify-export is (optioneel). Het afspelen van de muziek in de app zit al bij Pro en vereist geen Spotify.",
    proplus_buy_cta: "Koop Pro+ voor €4,99",
    proplus_loading: "Bezig...",
    proplus_later: "Later",
    proplus_unlock_cta: "Activeer Pro+",
    proplus_cta_homepage_h: "Wist je dat...",
    proplus_cta_homepage_p: "Met onze Music Bingo download je de complete playlist gratis naar Spotify. En met Pro+ (€4,99) kun je elke trekking direct in Spotify laten afspelen — perfect voor presentatoren.",
    proplus_cta_learn_more: "Bekijk Muziekbingo →",
    proplus_did_you_know: "Wist je dat?",
    play_next_song: "Speel volgende nummer af",
    host_proplus_h: "Activeer Pro+ — exporteer naar Spotify",
    host_proplus_p: "Bonus: zet je nummers in één klik op een Spotify-playlist. Afspelen in de app werkt al zonder Spotify.",
    spotify_connect_h: "Verbind je Spotify-account",
    spotify_connect_p: "Vereist Spotify Premium om nummers af te spelen.",
    spotify_login_btn: "Login bij Spotify",
    spotify_disconnect: "Koppel los",
    spotify_login_first: "Verbind eerst je Spotify-account",
    spotify_pause: "Pauze",
    spotify_resume: "Hervat",
    spotify_skip: "Volgende",
    spotify_prev: "Vorige",
    spotify_playing_on: "Speelt af op", spotify_this_device: "Deze computer (caller)", spotify_choose_device: "Kies een apparaat",
    spotify_refresh_devices: "Vernieuw apparaten", spotify_no_devices: "Geen apparaten gevonden. Open Spotify op het apparaat waar je wilt afspelen (bijv. de tablet) en klik op vernieuwen.",
    // Pro+ requires Pro first
    pro_required_h: "Eerst PRO activeren",
    pro_required_p: "PRO+ is een add-on bovenop een actief PRO account. Activeer eerst PRO (€9,95) om ongelimiteerd kaarten te maken, daarna kun je PRO+ erbij kopen voor Spotify integratie.",
    pro_required_buy_pro: "Koop PRO eerst — €9,95", pro_required_buy_pro_short: "Koop PRO eerst",
    pro_required_cancel: "Annuleer",
    // Activation CTAs on the 3-tier comparison
    tier_free_cta: "Start gratis",
    tier_pro_cta: "Activeer PRO",
    tier_proplus_cta: "Activeer PRO+Spotify",
    // Unique music bingo headline (homepage)
    unique_music_h: "UNIEKE Muziekbingo-modus",
    unique_music_p: "Speel met onze unieke Muziekbingo-modus — de muziek speelt direct in de app met albumhoes op groot scherm. Gratis demo met de eerste 10 nummers; Spotify-export is optioneel.",
    // Eyecatcher banner top of homepage
    eyecatcher_h: "Nu ook Muziekbingo die direct in de app speelt",
    eyecatcher_p: "Elk getrokken nummer speelt meteen af met albumhoes op groot scherm — geen Spotify of account nodig. Klik hier voor alle opties.",
    eyecatcher_cta: "Bekijk Muziekbingo",
    // Custom playlist tile + builder
    mb_custom_badge: "Eigen lijst",
    mb_custom_h: "Maak je eigen playlist",
    mb_custom_p: "Voeg zelf artiesten + nummers toe. Perfect voor een verjaardag of bruiloft.",
    mb_custom_cta: "Begin lege playlist",
    mb_custom_title_suffix: "Eigen playlist",
    music_format_hint_h: "Formaat:",
    music_format_hint_example: "Voorbeeld:",
    // === Music Bingo SEO long-form ===
    mb_seo_h1: "Muziekbingo maken — de muziek speelt direct in de app",
    mb_seo_p1: "Muziekbingo is hét feestspel waarbij spelers in plaats van nummers naar artiesten en titels luisteren. Onze gratis Muziekbingo generator maakt unieke kaarten in 3×3, 4×4 of 5×5 formaat — ideaal voor verjaardagen, bruiloften, personeelsfeesten en disco-avonden. Kies een van onze 14 voorgevulde genres (80's hits, 90's hits, Nederlandstalig, Duitstalig, Rock, Foute Muziek, Kerst, Disco, Hip-Hop, Schlager, Pop) óf bouw je eigen playlist met het simpele 'Artiest | Titel' formaat.",
    mb_seo_p2: "Wat onze Muziekbingo uniek maakt? De muziek speelt direct in de app. Elk getrokken nummer klinkt meteen als 30s-fragment met de albumhoes op groot scherm — geen Spotify, account of Premium nodig. Gratis demo met de eerste 10 nummers; met Pro speel je alle nummers.",

    mb_seo_h2_format: "Het Artiest | Titel formaat",
    mb_seo_format_p: "Wij gebruiken een simpel pipe-formaat ( | ) om artiest en titel van elkaar te scheiden. Op de bingokaart verschijnt de artiest klein en de titel groot. Voorbeelden van geldige regels:",
    mb_seo_format_more: "... en zo verder, tot 80+ nummers per playlist",

    mb_seo_h2_spotify: "Hoe speelt de muziek af?",
    mb_seo_spotify_p1: "Elk getrokken nummer speelt automatisch een fragment van 30 seconden af, met de albumhoes groot in beeld. Alles gebeurt direct in de app — geen Spotify, account of Premium nodig:",
    mb_seo_spotify_b1: "Automatische 30s-fragmenten met albumhoes bij elke trekking",
    mb_seo_spotify_b2: "Grote albumhoes om te casten naar een tweede scherm of tv",
    mb_seo_spotify_b3: "Raad-modus: verberg de titel tot jij 'm onthult",
    mb_seo_spotify_b4: "Werkt op laptop, tablet en mobiel — geen extra app of account nodig",

    mb_seo_h2_occasions: "Voor welke gelegenheden?",
    mb_seo_occasions_p: "Muziekbingo is perfect voor bedrijfsfeesten, vrijgezellenfeesten, bruiloften, verjaardagen, kerstborrels, koningsdag, eindfeesten op scholen en disco-avonden in cafés. Het werkt voor groepen van 4 tot 200+ spelers — print 1 kaart per persoon en je avond is gegarandeerd legendarisch.",

    mb_seo_h2_faq: "Veelgestelde vragen",
    mb_seo_faq1_q: "Heb ik een Spotify- of Premium-account nodig?",
    mb_seo_faq1_a: "Nee. De muziek speelt direct in de app via korte fragmenten met albumhoes — je hebt geen Spotify, account of Premium nodig. Gratis demo met de eerste 10 nummers; met Pro spelen alle nummers.",
    mb_seo_faq2_q: "Hoeveel nummers per playlist?",
    mb_seo_faq2_a: "Onze 14 voorgevulde genres hebben 75–100 unieke nummers elk. Voor een eigen playlist raden we minimaal 25 nummers aan (5×5 kaart). Hoe meer nummers, hoe meer variatie tussen de bingokaarten.",
    mb_seo_faq3_q: "Kan ik mijn eigen artiesten + titels toevoegen?",
    mb_seo_faq3_a: "Ja! Klik op de 'Maak je eigen playlist' tegel en voer je eigen lijst in met het formaat 'Artiest | Titel' (één per regel). Perfect voor specifieke verjaardagen of bruiloften.",
    mb_seo_faq4_q: "Werkt het ook op mobiel en tablet?",
    mb_seo_faq4_a: "Ja. De presenteer-modus en het afspelen werken in elke moderne browser op laptop, tablet en mobiel. Je kunt het tweede scherm (met albumhoes en QR-code) casten naar een tv of beamer.",
    // Music Bingo Spotify explainer
    mb_howto_badge: "Hoe het werkt",
    mb_howto_title: "Maak je eigen Spotify playlist",
    mb_howto_intro: "Op de bingokaarten staan alleen artiest en titel — geen audio. Je maakt zelf een gratis Spotify playlist met dezelfde nummers, en speelt die af tijdens je bingo-avond.",
    mb_step1_h: "Open Spotify",
    mb_step1_p: "Open Spotify op je telefoon, computer of TV. Een gratis account is voldoende — Premium is niet vereist.",
    mb_step2_h: "Zoek de nummers",
    mb_step2_p: "Zoek de artiest + titel uit jouw gekozen genre op en voeg ze één voor één toe aan een nieuwe playlist.",
    mb_step3_h: "Speel af tijdens bingo",
    mb_step3_p: "Druk op shuffle — Spotify speelt willekeurig nummers af. Spelers strepen de artiest/titel af die ze horen.",
    mb_option_a_h: "Optie A — Spotify shuffle",
    mb_option_a_p: "Eenvoudigst: zet je playlist op shuffle. Wanneer een nummer speelt, strepen alle spelers het af op hun kaart. Geen presentator nodig.",
    mb_option_b_h: "Optie B — Presenteer-modus",
    mb_option_b_p: "Voor controle: gebruik onze Bingo-Presentator. Bij elke trekking zoek je het nummer op Spotify en speel je het kort — perfect bij grotere groepen.",
    mb_unique_note: "💡 Tip: iedere artiest komt maar één keer voor in elke genrelijst — meer variatie op de kaarten.",
    mb_landing_h1_a: "Muziekbingo voor",
    mb_landing_h1_b: "elk feestje.",
    mb_landing_p: "Kies uit 14 muziekgenres — van Foute Muziek tot 80's hits. We vullen je kaarten automatisch met 75+ nummers (artiest + titel).",
    mb_landing_cta: "Bekijk alle genres",
    mb_landing_genres_more: "+ 5 andere genres — bekijk alles ›",
    themes_section_badge: "Bingo thema's",
    themes_section_h_a: "Of kies een",
    themes_section_h_b: "kant-en-klaar thema.",
    themes_section_p: "13 themes met meer dan 80 woorden per stuk — direct printen of online spelen. Klik om meer te lezen.",
    themes_section_view: "Bekijk",
    nav_home: "Home",

    // Homepage SEO content sections (2026-08-16) — targets money keywords
    // per GSC gap analysis: "bingokaarten generator", "bingo maker", etc.
    seo_intro_h: "Wat is een bingokaarten generator?",
    seo_intro_p: "Een bingokaarten generator is een online tool waarmee je in enkele seconden professionele, unieke bingokaarten maakt — met eigen tekst, foto's of één van onze 15 kant-en-klare thema's. Geen software installeren, geen ontwerp-kennis nodig. Kies je formaat (3x3, 4x4 of 5x5), vul de kaart en download een print-klare PDF of speel direct online. Iedere kaart wordt automatisch geschud, dus geen twee spelers krijgen dezelfde combinatie. Perfect voor scholen, kinderfeestjes, familiebijeenkomsten, bedrijfsborrels en muziekbingo-avonden.",
    seo_why_h: "Waarom onze bingokaarten generator?",
    seo_why_p: "In tegenstelling tot statische PDF-templates op andere sites, maakt onze generator écht unieke kaarten met slimme shuffle-algoritmes. Je krijgt tot 20 kaarten gratis, kunt eigen afbeeldingen uploaden voor thema-feestjes, hebt keuze uit 3 kaartformaten en print in 1, 2, 3 of 4 kaarten per A4 om papier te besparen. Bovendien kun je online spelen: elke deelnemer krijgt via een QR-code een eigen bingokaart op de telefoon — geen app-download nodig. Vanaf €9,95 per sessie ontgrendel je onbeperkt kaarten voor grote groepen.",
    seo_who_h: "Voor wie is deze bingo maker?",
    seo_who_school_h: "Voor scholen & leraren",
    seo_who_school_p: "Rekenbingo, taalbingo, letterbingo of gewoon Sinterklaas-bingo in de klas — de generator ondersteunt zowel tekst als afbeeldingen. Print in enkele minuten 30 unieke kaarten voor de hele klas, of speel klassikaal met de presentator-modus op het digibord. Populair bij docenten in het basisonderwijs én VO.",
    seo_who_party_h: "Voor feestjes & familie",
    seo_who_party_p: "Verjaardag, kerstdiner, vrijgezellenfeest of babyshower — kies een thema en print de kaarten. Gebruik eigen foto's van de jarige voor extra persoonlijke bingo. Werkt ook perfect als ice-breaker bij bruiloften met de 'gebeurtenissen-bingo' variant.",
    seo_who_business_h: "Voor bedrijven & teams",
    seo_who_business_p: "Kerstborrel-bingo, teambuilding-bingo of meeting-bingo. Ideaal voor kantoor-events waarbij niet iedereen elkaar kent. Print kaarten per team of speel online tijdens een remote borrel. Voeg branding en logo's toe met de Pro-sessie.",
    seo_how_h: "Hoe werkt de bingo generator?",
    seo_how_p: "Drie stappen: (1) kies een thema of begin blanco, (2) laat de 80+ voorgevulde items staan of typ eigen tekst / upload foto's, (3) kies het aantal kaarten en klik op Genereer. Je krijgt een print-klare PDF óf een unieke deel-code om online te spelen. Duurt letterlijk 30 seconden.",
    seo_trust_stat_1_v: "20",
    seo_trust_stat_1_l: "kaarten gratis",
    seo_trust_stat_2_v: "15+",
    seo_trust_stat_2_l: "kant-en-klare thema's",
    seo_trust_stat_3_v: "3",
    seo_trust_stat_3_l: "formaten (3x3, 4x4, 5x5)",
    seo_trust_stat_4_v: "€0",
    seo_trust_stat_4_l: "startkosten, geen account",
    // Why-BingoMaker USP block (GEO step 5, 2026-08-17)
    why_badge: "Waarom bingocards-generator",
    why_bingo_maker_h: "Alles wat je nodig hebt voor bingo — in één tool",
    why_bingo_maker_p: "De enige online bingo generator met AI, muziek die direct in de app speelt, live caller én scoreboard. Voor scholen, feestjes, bedrijfsuitjes en muziekbingo-avonden.",
    why_feat_ai: "AI bingo generator",
    why_feat_spotify: "Muziek in de app",
    why_feat_music: "Muziekbingo",
    why_feat_online: "Online spelen",
    why_feat_caller: "Live bingo caller",
    why_feat_scoreboard: "Live scoreboard",
    why_feat_unique: "Unieke bingokaarten",
    why_feat_pdf: "PDF downloaden",
    why_feat_mobile: "Mobiel spelen",
    why_feat_i18n: "Nederlands / Engels / Duits",
    why_feat_groups: "Geschikt voor grote groepen",

    // Spotify banner — homepage flagship (2026-08-16). Highlights the unique
    // Spotify Web Playback integration (Pro+ tier).
    spotify_banner_h: "Muziekbingo die direct in de app speelt — geen Spotify of account nodig",
    spotify_banner_p: "De bingo-caller trekt een nummer én speelt het meteen af met albumhoes op groot scherm. Gratis demo met de eerste 10 nummers. Optioneel exporteren naar Spotify.",
    spotify_feat_1: "Elk nummer speelt direct af (30s-fragment + albumhoes)",
    spotify_feat_2: "Play / pauze / skip in de caller",
    spotify_feat_3: "Werkt met elk genre of je eigen lijst",
    spotify_feat_4: "Gratis demo · Pro speelt alles af",
    spotify_banner_cta: "Maak een muziekbingo",
    spotify_banner_more: "Meer over Muziek Bingo",

    // AI Theme Generator (NEW — flagship feature)
    ai_badge: "✨ NIEUW · AI",
    ai_nav_pill: "✨ AI Generator",
    ai_btn: "✨ AI Bingo Generator",
    ai_btn_short: "✨ AI",
    ai_modal_title: "Beschrijf je thema — AI doet de rest",
    ai_modal_subtitle: "Vertel ons waar de bingo over moet gaan. Onze AI genereert in 5 seconden tot 80 unieke, originele bingo items in het Nederlands.",
    ai_prompt_label: "Wat is het thema?",
    ai_prompt_placeholder: "Bijv. \"Strandvakantie in Griekenland\" of \"60-jarig huwelijksfeest\" of \"Eerste schooldag groep 5\"",
    ai_count_label: "Aantal items",
    ai_count_hint: "30 items is perfect voor een 5×5 raster met 10+ spelers.",
    ai_generate_btn: "✨ Genereer bingo items",
    ai_generating: "AI is aan het werk…",
    autogen_wait: "De AI stelt je bingokaarten samen…",
    ai_autogen_done: "kaarten klaar — pas aan of download meteen!",
    sp_pl_title: "Zet deze bingo op Spotify",
    sp_pl_desc: "Maak automatisch een afspeelbare Spotify-playlist van alle nummers — deel de link met je host.",
    sp_pl_btn: "Maak Spotify-playlist",
    sp_pl_login_note: "Je logt éénmalig in bij Spotify (ook gratis account werkt).",
    sp_pl_creating: "Playlist maken…",
    sp_pl_done: "Je Spotify-playlist staat klaar!",
    sp_pl_open: "Open in Spotify",
    sp_pl_copy: "Kopieer link",
    sp_pl_copied: "Link gekopieerd!",
    sp_pl_added: "nummers toegevoegd van",
    sp_pl_notfound: "Niet gevonden op Spotify:",
    sp_pl_error: "Playlist maken mislukt. Probeer opnieuw.",
    sp_pl_not_registered: "Je Spotify-account heeft nog geen toegang tot deze app. Neem contact op met de beheerder zodat je Spotify-e-mailadres wordt toegevoegd.",
    sp_pl_house_down: "De Spotify-koppeling is tijdelijk niet beschikbaar. Download de nummerlijst of probeer het later opnieuw.",
    sp_pl_need_songs: "Genereer eerst een muziekbingo met nummers.",
    sp_pl_locked_title: "Spotify-playlist aanmaken (PRO+)",
    sp_pl_locked_note: "Het automatisch aanmaken van een échte Spotify-playlist zit in PRO+ (Spotify-koppeling). Met PRO kun je de nummerlijst wel downloaden en zelf importeren.",
    sp_pl_locked_cta: "Activeer PRO+ Spotify",
    ai_remaining_label: "AI generaties vandaag",
    ai_limit_reached: "Dagelijkse limiet bereikt. Probeer morgen opnieuw of upgrade naar PRO.",
    ai_error: "Er ging iets mis. Probeer een ander thema.",
    ai_success_toast: "AI heeft {n} items gegenereerd!",
    ai_apply_btn: "Gebruik deze items",
    ai_regenerate_btn: "Genereer opnieuw",
    ai_preview_heading: "Wat de AI bedacht",
    ai_title_label: "Voorgestelde titel",
    ai_hero_promo: "🤖 Op zoek naar inspiratie? Onze AI bedenkt 30 unieke items uit één zin.",
    ai_landing_h: "Bingo bouwen met AI",
    ai_landing_p: "Type één zin (\"Sinterklaas voor groep 3\" of \"50e verjaardag Marleen\") en onze AI levert 30 originele items in het Nederlands. Klik. Print. Spelen.",
    ai_landing_cta: "Probeer AI Generator",
    ai_examples_label: "Op zoek naar inspiratie? Probeer:",
    ai_example_1: "Strandvakantie Italië",
    ai_example_2: "Kantoor kerstfeest",
    ai_example_3: "Eerste schoolweek",
    ai_example_4: "60-jarig huwelijk",
    ai_prompt_required: "Vul een thema in",
    // Music Bingo — compact above-the-fold pricing strip
    mb_strip_title: "Hoe wil je Muziekbingo spelen?",
    mb_strip_compare: "Vergelijk volledig",
    mb_strip_free_h: "Gratis",
    mb_strip_free_p: "20 kaarten + demo van 10 nummers",
    mb_strip_pro_h: "Pro",
    mb_strip_pro_p: "Alle nummers afspelen + presenteer-modus",
    mb_strip_proplus_h: "Pro+Spotify",
    mb_strip_proplus_p: "Auto-play vanuit jouw Spotify Premium",
    // Mobile Play Preview — phone storyboard
    mp_badge: "Mobiel spelen",
    mp_title: "Zo speelt iedereen mee — gewoon op de telefoon",
    mp_intro: "Geen app nodig. Eén deel-link of QR-code en spelers krijgen automatisch hun eigen unieke kaart. Tikken op een vakje is afstrepen. Bij vijf op een rij detecteert het systeem automatisch BINGO!",
    mp_step1_badge: "1. Join",
    mp_step1_label: "Scan QR of voer 4-letter code in",
    mp_step2_badge: "2. Speel",
    mp_step2_label: "Tap om af te strepen — eigen unieke kaart",
    mp_step3_badge: "3. Win",
    mp_step3_label: "Automatische BINGO detectie + Wall of Fame",
    mp_join_kicker: "MEEDOEN",
    mp_scan_or_code: "Scan of vul code in",
    mp_or_code: "of code",
    mp_tap_to_mark: "Tik om af te strepen",
    mp_auto_detect: "Vijf op een rij!",
    mp_wall_of_fame: "Je staat op de Wall of Fame",
    mp_b1_h: "Geen download nodig",
    mp_b1_p: "Werkt direct in de browser op iedere telefoon (iOS & Android).",
    mp_b2_h: "Iedereen een unieke kaart",
    mp_b2_p: "Eén deel-link verdeelt automatisch verschillende kaarten over alle spelers.",
    mp_b3_h: "Auto BINGO-detectie",
    mp_b3_p: "Het systeem checkt automatisch op rij, kolom, diagonaal of volle kaart.",
    mp_real_screens: "Echte schermafbeeldingen",
    mp_real_player_h: "Speler weergave",
    mp_real_player_p: "Iedere speler ziet zijn eigen unieke kaart. Tik om af te strepen of roep BINGO.",
    mp_real_share_h: "Delen in 1 klik",
    mp_real_share_p: "QR-code, deel-link en kant-en-klare WhatsApp-uitnodiging. Plak en klaar.",
    mp_real_host_h: "Presentator dashboard",
    mp_real_host_p: "Live scorebord, patroon kiezen, Spotify integratie en bingo-claims valideren.",
    mp_real_blurb: "Zien hoe het er écht uitziet? Bekijk de drie live schermen (speler · delen · presenteer) in volledige grootte.",
    mp_real_open_cta: "Bekijk echte schermafbeeldingen",
    proplus_includes_pro: "Inclusief alles uit Pro",
    proplus_music_only: "Alleen voor Muziekbingo",
    email_label: "Je e-mailadres",
    email_placeholder: "naam@voorbeeld.nl",
    email_help: "We mailen je de speel-link en (eenmalige) bewerk-link.",
    email_optional_toggle: "E-mail toevoegen (optioneel)",
    email_required_paid: "E-mailadres is verplicht voor een betaalde sessie.",
    email_invalid: "Vul een geldig e-mailadres in.",
    promo_have_code: "Heb je een promocode?",
    promo_code_label: "Promocode",
    promo_check: "Check",
    promo_invalid: "Code is ongeldig of al gebruikt",
    promo_free_detected: "✓ Gratis code! De sessie wordt zonder betaling vrijgegeven.",
    promo_discount_detected: "✓ Kortingscode geldig",
    promo_applied_unlocked: "Sessie ontgrendeld via promocode!",
    promo_unlock_free: "Ontgrendel gratis",
    edit_token_unlocked: "Bewerk-rechten geactiveerd. Pas je bingo aan en sla opnieuw op.",
    edit_token_used: "Deze bewerk-link is al gebruikt.",
    edit_token_invalid: "Bewerk-link is ongeldig.",
    set_not_found: "Bingo set niet gevonden",
    loaded_existing_set: "Bingo geladen",
    call_sheet_subtitle: "Streep af tijdens het spelen",
    call_sheet_footer: "%d termen — kruis ze aan tijdens het spelen.",
    call_sheet_button: "Presenteer verzamelsheet",
    ai_music_tip_h: "Tip voor Muziekbingo",
    ai_music_tip_p1: "Op zoek naar artiesten en titels? Vraag de AI om het formaat",
    ai_music_tip_p2: "te gebruiken (bv. 'Queen | Bohemian Rhapsody'). Zo toont elke kaart artiest én titel duidelijk — én Spotify zal dan feilloos werken.",
    ai_free_bullet: "AI thema generator (10/dag)",
    ai_pro_bullet: "AI thema generator (10/dag)",
    ai_proplus_bullet: "AI helpt direct met 'Artiest | Titel' formaat — ook Spotify werkt dan feilloos",
    tier_proplus_cta_long: "Activeer Pro+Spotify",
  },
  en: {
    nav_create: "Create", free_remaining: "free left", unlocked: "Pro active",
    free_daily_intro: "Free: 1 bingo per day —", free_daily_cards_left: "cards left today", free_daily_used: "You've used today's free bingo.", free_next_in: "free again in ~", hours_short: "h",
    pw_daily_title: "Today's free bingo is used", pw_daily_body: "You get 1 free bingo (up to 20 cards) per 24 hours. Upgrade now for unlimited, or come back later —",
    hero_badge: "20 free cards · 15 themes",
    hero_h1_main: "bingocards-generator",
    hero_h1_sub: "The complete online bingo generator.",
    hero_subtitle_new: "Bingo card generator with AI, music bingo, live caller & PDF. For schools, parties & offices — print free or play online, no account needed.",
    hero_promise_h1: "Organise a complete bingo in 5 minutes",
    hero_promise_sub: "Create your bingo cards for free, share them with your players and play along online right away.",
    hero_cta_primary: "Create your free bingo",
    hero_cta_secondary: "See how it works",
    hero_trust: "No credit card · no account · start for free",
    hero_benefit_1: "Ready in minutes",
    hero_benefit_2: "Print or play online",
    hero_benefit_3: "For any occasion",
    trust_fact_1: "No account needed",
    trust_fact_2: "20 cards free",
    trust_fact_3: "Print or play online",
    trust_fact_4: "NL · EN · DE",
    // ── FASE C: generator quick-start + "bingo ready" success moment ──
    qs_title: "Quick start in 3 steps",
    qs_dismiss: "Skip",
    qs_step1: "Pick your bingo",
    qs_step2: "For how many players?",
    qs_step3: "Make your bingo",
    qs_type_words: "Word bingo", qs_type_words_desc: "Your own words or a theme",
    qs_type_music: "Music bingo", qs_type_music_desc: "Plays in the app",
    qs_type_numbers: "Number bingo", qs_type_numbers_desc: "Classic 1–75 or 1–90",
    qs_type_ai: "Let AI do it", qs_type_ai_desc: "Describe your theme",
    qs_players_hint: "Usually 1 card per player — you can change this later.",
    qs_players_custom: "Other",
    qs_players_unit: "players",
    qs_next: "Next", qs_back: "Back",
    qs_make: "Make my bingo",
    qs_fill_words: "Add your words below (or use a theme), then make the cards.",
    ready_title: "Your bingo is ready!",
    ready_subtitle: "cards ready to print or play online.",
    ready_download: "Download PDF", ready_download_desc: "Print at home or school",
    ready_online: "Play online", ready_online_desc: "Share via QR code",
    ready_caller: "Live caller", ready_caller_desc: "Present on a beamer or smartboard",
    ready_upgrade_line: "Online play & live caller are in PRO — from €9.95 per session.",
    ready_upgrade_cta: "See PRO",
    ready_locked: "PRO",
    // ── FASE D: honest payment-trust + use-cases (no fabricated reviews) ──
    pay_trust_1: "One-time payment, no subscription",
    pay_trust_2: "Secure payment via iDEAL & Stripe",
    pay_trust_3: "No account required",
    pay_trust_4: "20 cards free to try",
    hero_spotify_badge: "Music plays in the app",
    usecases_badge: "For every occasion",
    usecases_h: "What do people use bingocards-generator for?",
    usecases_p: "From classroom to pub — the same generator, endless occasions.",
    uc_school_h: "Schools & classroom", uc_school_p: "Maths, spelling or ESL bingo for the whole class, ready before the bell.",
    uc_party_h: "Kids' parties", uc_party_p: "Theme bingo with your own photos and words — the icebreaker at any party.",
    uc_office_h: "Companies & team building", uc_office_p: "Get-to-know-you and meeting bingo for team days and staff parties.",
    uc_wedding_h: "Weddings", uc_wedding_p: "Personal bingo with memories of the couple for the guests.",
    uc_music_h: "Music nights", uc_music_p: "Music bingo that plays right in the app — cheesy Christmas, 80s/90s and more.",
    uc_care_h: "Care & seniors", uc_care_p: "Large, easy-to-read cards with numbers or words for activities.",
    tile_ai_h: "AI theme generator", tile_ai_p: "Any topic — ready-to-print cards in 15 seconds.",
    tile_music_h: "Music bingo", tile_music_p: "14 genres · plays in the app · 80s, 90s, wedding, office party.",
    tile_live_h: "Live caller", tile_live_p: "Present on projector or smartboard with scoreboard.",
    tile_print_h: "PDF & play online", tile_print_p: "Print at home or share via QR code on any phone.",
    tile_cta: "Open",
    nav_compare: "Compare",
    footer_compare: "Compare 2026",
    nav_which_today: "Which bingo do you want?",
    nav_group_popular: "Popular",
    nav_group_tools: "Tools",
    nav_group_info: "More",
    menu_music_spotify: "Music bingo with sound",
    menu_music_spotify_sub: "Songs play right in the app",
    menu_music_only: "Music bingo — cards only",
    menu_music_only_sub: "14 genres, print or play online",
    menu_number_bingo: "Number bingo 75 / 90",
    menu_number_bingo_sub: "Ready-made number cards (1-75 & 1-90)",
    menu_ball_drawer: "Bingo ball caller",
    menu_ball_drawer_sub: "Online caller — auto-draws the balls",
    menu_theme_bingo: "Theme bingo",
    menu_theme_bingo_sub: "Christmas, birthday, wedding, kids",
    menu_sinterklaas: "Sinterklaas bingo",
    menu_sinterklaas_sub: "Picture & music bingo — ready to print",
    menu_ai_bingo: "AI-generated bingo",
    menu_ai_bingo_sub: "Describe your event — AI does the rest",
    menu_custom_bingo: "Custom bingo",
    menu_custom_bingo_sub: "Upload your own words or photos",
    landing_choose_h: "Which bingo do you want?",
    landing_choose_p: "Pick your type — playing in 30 seconds. Print free or play online.",
    hero_title_a: "Make", hero_title_b: "bingo cards", hero_title_c: "that", hero_title_d: "actually", hero_title_e: "rock.",
    hero_subtitle: "A ready-to-print bingo generator for teachers, parents & bingo presenters. Text or images, classic or bulk. No account needed.",
    cta_start: "Start free", cta_bulk: "Bulk generator", no_card_needed: "No credit card. No account. Start now.",
    features_title: "One tool. Every bingo. No fuss.",
    features_subtitle: "bingocards-generator is fully AI-based, with sharp typography, 15 ready themes, a unique host view, unique share-codes and auto card-assignment.",
    f1_title: "3x3, 4x4, 5x5", f1_desc: "All sizes. Classic 5x5 with FREE middle or compact for kids.",
    f2_title: "Text or images", f2_desc: "Upload images or type text. Perfect for theme parties & lessons.",
    f3_title: "15 themes", f3_desc: "Christmas, Halloween, Music, Easter, Wedding and more — ready to use.",
    f4_title: "PDF & Share", f4_desc: "Print perfect or share one link — each player gets a unique card.",
    themes_title: "15 ready themes", view_all: "View all",
    how_works: "How it works", how_intro: "From idea to print<br/>in three steps.",
    how1_t: "Pick theme", how1_d: "Click any of the 15 themes, or start blank.",
    how2_t: "Fill in", how2_d: "Type, upload images, or auto-fill from the theme.",
    how3_t: "Print or share", how3_d: "Download PDF, or share one link so each player gets a unique card.",
    prices: "Pricing",
    pricing_title: "20 free cards. from €9.95 per session.",
    pricing_subtitle: "One-time payment per session. Branding, host mode and share-codes only during paid sessions. iDEAL & card.",
    free_plan: "Free", paid_plan: "Pro session", per_session: "per session · once per session of 20+ cards",
    always: "Always free", popular: "Popular", try_no_account: "Try everything, no account.",
    free_f1: "1 free bingo per day (up to 20 cards)", free_f2: "All 15 themes & sizes", free_f3: "PDF download", free_f4: "Text & image upload",
    locked_f1: "Own logo & brand name", locked_f2: "Host mode (draw numbers)", locked_f3: "Online share-code", locked_f4: "Auto card-assignment per player",
    pro_f1: "Unlimited cards in this session", pro_f2: "All themes, sizes, PDF",
    pro_f3: "Own logo & brand name", pro_f4: "Host mode (draws + bingo check)",
    pro_f5: "Online share-code", pro_f6: "Auto card-assignment — 1 link, 100 players, all different",
    pro_f7: "Custom FREE word on cards", pro_f8: "Live scoreboard with 'almost-bingo' alerts",
    pro_f_music1: "Music-bingo presenter mode: every song plays with big album art on the big screen",
    pro_f_music2: "Guess mode + QR screen so players join and play instantly",
    cta_make_first: "Create your first card",
    builder_title: "Bingo maker", one_card: "Single card", bulk_gen: "Bulk generator",
    generator: "Generator",
    items: "items", ready: "ready", more_needed: "more needed",
    need_minimum: "At least", items_for_size: "items required for size", currently_have: "You currently have",
    min_items_explainer: "Required count for size",
    your_card: "YOUR CARD",
    add_items_first: "Please add items first.",
    you_are: "Playing as", change: "edit",
    name_explainer: "Enter your name to join. Others will see you on the leaderboard once you start winning!",
    live_status: "Live status",
    psm_title: "Your bingo cards are ready … now what?",
    psm_subtitle: "Follow this 3-step plan and everyone is playing within minutes.",
    psm_step: "Step",
    psm_your_task: "Your task",
    psm_step1_title: "Share the bingo cards with your players",
    psm_step1_task: "Generate a QR code and show it",
    psm_qr_label: "QR code — scan & play",
    psm_qr_explainer: "Print or display this QR code so participants instantly get their own card on their phone. Great for invitations too.",
    psm_qr_download: "Download QR code",
    psm_code_label: "Share code & link",
    psm_code_explainer: "Paste this code or link into your invitation email, WhatsApp or calendar invite. Anyone who opens the link automatically receives a unique card.",
    psm_step2_title: "Every participant gets a unique card",
    psm_step2_explainer: "When a player first opens the link, one of your generated cards is automatically assigned. Returning visits show the same card — no confusion.",
    psm_step3_title: "Tap 'Present' to become the host",
    psm_step3_explainer: "As the bingo host, the presenter screen opens. There you choose the bingo pattern per round, see all players live, validate bingo claims and review any card at a glance.",
    psm_have_fun: "Have fun playing!",
    psm_help: "Something not working?",
    psm_protip_label: "Pro tip",
    psm_copy_invite: "Copy invitation (WhatsApp)",
    psm_invite_copied: "Invitation copied! Paste it in WhatsApp or e-mail.",
    psm_invite_template: "🎉 Bingo-time! Wanna join?\n\nTap the link to receive your own unique card — just open it on your phone.\nDon't forget to fill in your name!\n\n👉 Play: {url}\n\nSee you there!",
    psm_reopen: "Reopen guide",
    edit_applied: "Edit saved on the same code",
    edits_left_suffix: "edit left",
    session_consumed: "Session used. A new set costs €9.95.",
    edit_quota_exceeded: "You already edited once. Further changes require a new session.",
    settings: "Card settings", title_label: "Title", size_label: "Size", free_middle: "FREE middle",
    free_word: "FREE word", theme: "Theme", branding: "Branding (Pro)", brand_name_label: "Brand name (subtitle)",
    logo_label: "Logo (PNG/JPG, max 1MB)", logo_size_label: "Logo size", upload: "Upload", replace: "Replace", optional: "Optional",
    actions: "Actions", shuffle: "Shuffle", clear: "Clear", download_pdf: "Download PDF",
    cards_per_page: "Cards per page",
    bulk_settings: "Bulk settings", num_cards: "Card count", items_list: "Items list (1 per line)",
    images_opt: "Images (optional)", generate: "Generate", download: "Download",
    share_title: "Share & host (Pro only)", share_desc: "Save cards online with a share-code. Each player opening the link is auto-assigned a different card.",
    save_get_code: "Play & present!", your_code: "Your code", copy_link: "Copy link",
    view: "View", present: "Host", pro_only_lock: "Pro feature",
    editor: "Editor", print_preview: "Print preview", preview: "Preview", no_cards_yet: "No cards yet.", fill_and_click: "Fill in your list and click",
    preview_one_of: "card 1 of",
    preview_one_of_x: "card {n} of {total}",
    preview_pdf_match: "This is exactly how your PDF will look — 1-on-1.",
    pick_card: "Pick card",
    card: "Card",
    reshuffle_btn: "New round, new cards",
    reshuffle_hint: "Regenerate all cards with random positions — same item list",
    reshuffled_toast: "New cards generated!",
    cell_help: "Click a cell to add text. Use the 📷 icon to upload an image.",
    pro_only_panel: "Available during a Pro session (€9.95).", pro_active: "Pro active", unlock_pro: "Unlock Pro",
    fill_with: "Fill with", content: "content", busy: "Working…",
    fill_with_short: "Fill theme",
    themes_show: "Other themes", themes_hide: "Hide",
    cross_examples_h: "Browse 9 AI bingo examples",
    cross_examples_p: "Birthday, wedding, classroom, office, bachelorette and more. One click loads the items into the generator.",
    cross_examples_cta: "Examples gallery",
    cross_caller_badge: "Bingo Caller",
    cross_caller_h: "Draw bingo numbers online",
    cross_caller_p: "Free bingo caller for 1-75 or 1-90. Works directly in your browser. Embeddable on your own site.",
    cross_caller_cta: "Open bingo caller",
    play_assigned: "You were auto-assigned", play_card: "card", play_total: "total cards",
    your_name: "Your name (for host)", call_bingo: "Call BINGO!", sending: "Sending…",
    valid_bingo: "Verified: your card has a valid bingo line.", invalid_bingo: "No valid bingo line yet.",
    claimed_at: "Claimed at", presenter_sees: "The host sees you in the scoreboard.",
    host_locked_title: "Host mode is Pro",
    host_locked_desc: "Unlock a Pro session (€9.95) to draw numbers, verify bingos and see players claim live.",
    unlock_session: "🎟️ Unlock this session", or_view_player: "Or view a card as player",
    last_draw: "Last draw", click_draw_to_start: "Click",
    draw_next: "Draw next", drawing: "Drawing…", reset: "Reset",
    all_drawn_items: "All items", presenter: "HOST · CODE",
    cards: "cards", claims: "claims", drawn: "drawn",
    view_player_view: "View player-view",
    scoreboard: "Live scoreboard", bingo_claims: "🎉 Bingo claims",
    no_claims_yet: "No claims yet. Players get a", almost_bingo: "🔥 Almost bingo",
    away: "needs", to_go: "more",
    new_claims: "New claims", show: "Show", accept: "Accept", reject: "Reject",
    winners: "Winners",
    check_card_title: "Check card",
    bingo: "BINGO", no_bingo: "No bingo", full_house: "Full house", marked_count: "marks",
    fill_card_num: "Enter a card number.",
    payment_success_title: "Payment successful!", payment_success_desc: "Your account is unlocked. Make unlimited cards now.",
    back_to_builder: "Continue", payment_polling: "Checking payment…", payment_unknown: "Status unknown",
    payment_unknown_desc: "We couldn't confirm your payment yet. Try again later.",
    back_to_maker: "Back to maker",
    payment_cancelled: "Payment cancelled", payment_cancelled_desc: "No problem — try again whenever you're ready.",
    pw_golden: "Golden ticket", pw_unlock_all: "Unlock everything",
    pw_intro: "You've used your", pw_intro_2: "free cards.", pw_intro_3: "Pick a package and unlock more cards instantly.",
    pw_intro_more: "Unlock Pro to create, print and share unlimited cards.",
    proplus_cta_builder: "Music bingo? Export to Spotify (Pro+)",
    gate_title: "One more step",
    gate_body: "Enter your email — we'll save your bingo and send you a link to view, print and edit it later.",
    gate_confirm: "Save & continue",
    gate_skip: "Continue without saving",
    sp_connected_ok: "Spotify connected! You can now create your playlist.",
    sp_connect_err: "Connecting to Spotify failed. Please try again or log in again.",
    proplus_connect_h: "One more step: connect Spotify",
    proplus_connect_p: "Link your Spotify account so you can instantly create a playable playlist and present.",
    stepper_done: "Done",
    step_create: "Create", step_create_sub: "Fill in & generate",
    step_pro: "Pro", step_pro_sub: "Unlock everything",
    step_save: "Save", step_save_sub: "Save & email link",
    step_proplus: "Pro+", step_proplus_sub: "Spotify upgrade",
    step_spotify: "Spotify", step_spotify_sub: "Connect account",
    step_present: "Present", step_present_sub: "Start the bingo",
    save_first_to_present: "Save your bingo first, then you can present.",
    menu_title: "What do you want to do?",
    menu_call_sheet: "Present caller sheet",
    menu_play_present: "Play & present",
    menu_activate_spotify: "Activate Spotify integration",
    menu_activate_note: "One-off €4.99 — unlocks real Spotify playlists.",
    menu_generate_first: "Generate your cards first.",
    menu_call_sheet_help: "All items to read out loud.",
    menu_download_help: "Save the song list as a file.",
    menu_demo_btn: "Try the music bingo (free)",
    menu_demo_help: "Hear the first 10 songs with album art — this is how your bingo sounds.",
    missing_clips_title: "Not all songs were found",
    missing_clips_desc: "We couldn't find a clip or album art for these songs:",
    missing_clips_hint: "Tip: tweak the artist/title in your song list, or replace them while presenting via 'Find a clip'.",
    missing_clips_ok: "Got it",
    bs_start_title: "The music bingo is about to begin!",
    bs_start_scan: "Scan the QR code to join",
    bs_joined_label: "players ready to play",
    bs_joined_one: "player ready to play",
    menu_spotify_help: "Bonus: export your songs to a Spotify playlist.",
    menu_play_help: "Play the music right in the app and present on the big screen.",
    menu_activate_spotify_short: "Activate Spotify",
    cs_title: "Caller sheet",
    cs_items: "items",
    cs_tab_list: "List",
    cs_tab_caller: "Caller mode",
    cs_copy: "Copy all items",
    cs_copied: "Copied",
    cs_copy_toast: "All items copied to clipboard",
    cs_copy_fail: "Copy failed — please select manually",
    cs_board: "Full screen",
    cs_board_title: "Full screen (for smart board)",
    cs_fs_unsupported: "Full screen not supported",
    cs_print: "Print",
    cs_close: "Close",
    cs_list_desc_a: "These items are in random order — perfect to read out during the bingo. Click",
    cs_list_desc_b: " to paste them into Word, PowerPoint or your smart-board app.",
    cs_current: "Current call",
    cs_ready: "Ready to start",
    cs_of: "of",
    cs_called: "called",
    cs_togo: "to go",
    cs_all_called: "All items called",
    cs_start: "Start (Space)",
    cs_next: "Next (Space)",
    cs_reset: "Reset",
    cs_recent: "Recently called",
    cs_tip: "Tip: click 'Full screen' for your smart board. In caller mode, press the space bar for the next item.",
    proplus_connect_btn: "Connect with Spotify",
    pw_b1: "Unlimited cards this session", pw_b2: "Branding (logo + brand name)",
    pw_b3: "Host mode + scoreboard", pw_b4: "Own images & themes",
    pw_pay: "Pay with iDEAL / card", pw_later: "Maybe later",
    restore_cta: "Already paid? Restore your purchase",
    restore_email_label: "Email you paid with",
    restore_email_ph: "you@example.com",
    restore_btn: "Restore",
    restore_hint: "We'll link your earlier payment to this device.",
    restore_ok: "Purchase restored! Your Pro access is active again on this device.",
    restore_none: "No paid purchase found for this email address.",
    restore_invalid: "Please enter a valid email address.",
    restore_fail: "Restore failed. Please try again later.",
    ps_paid_h: "Payment successful!",
    ps_paid_p: "Your account is unlocked. Create your bingo cards now.",
    ps_continue: "Continue creating",
    ps_checking_h: "Checking payment…",
    ps_checking_p: "One moment, we're confirming your payment.",
    ps_unknown_h: "Status unknown",
    ps_unknown_p: "We couldn't confirm your payment yet. Check back later or try again.",
    ps_back: "Back to builder",
    upsell_h: "Making a music bingo?",
    upsell_p: "Want to integrate Spotify so the music plays instantly during the game?",
    upsell_note: "*Requires a Spotify Premium account.",
    upsell_btn: "Yes, add Spotify (+€4.99)",
    from_price: "from", tier_upto: "Up to", tier_cards: "cards", tier_unlimited: "Unlimited cards",
    tier_per_session: "One-time per session", tier_popular: "Most popular", tier_you_pay: "You pay",
    pw_secure: "Secure payment via Stripe. iDEAL, credit card, and more.",
    eenmalig: "one-time",
    on: "ON", off: "OFF", default_title: "My Bingo", optional_placeholder: "Optional",
    save_failed: "Save failed.", saved_code: "Saved! Code:", link_copied: "Link copied!",
    cells_first: "Fill in some cells first.", choose_theme_first: "Pick a theme with content first.",
    loaded: "loaded!",
    number_bingo: "Number bingo", number_bingo_desc: "Classic bingo with numbers 1–75 or 1–90 (no theme). 5x5 grid with FREE.",
    generate_n_cards: "Generate", num_to: "1 to", make_or_generate_first: "Create or generate cards first.",
    free_left_msg: "You have", free_left_left: "free cards left.", numbers_generated: "number bingo cards (1-",
    cards_generated: "cards generated!", pro_test_active: "Pro test active", pro_deactivate: "Deactivate",
    pro_deactivate_confirm: "Deactivate Pro? You'll get a new client-id with 20 free cards.",
    confirm_click_again: "Click again",
    activate_pro_test: "🧪 Activate Pro test", pro_test_activated: "🧪 Pro test session activated — all features unlocked!",
    pro_test_failed: "Could not activate test session.",
    pdf_failed: "PDF generation failed.", generate_first: "Generate the cards first.",
    cards_count: "cards", pdf_downloaded: "cards downloaded!",
    pro_highlight_title: "Pro makes it truly big",
    pro_highlight_subtitle: "One-time €9.95 per session. All features unleashed, for your whole event.",
    pro_cta: "Activate Pro",
    view_demo: "View demo scoreboard",
    next_round: "Next round", next_round_confirm: "Start next round? You can pick a pattern after. Drawn items are kept.",
    next_round_hint: "Open the next-round options: pick pattern and reshuffle cards",
    next_round_title: "Start next round",
    next_round_desc: "Pick a pattern and optionally reshuffle the cards. Players will see the new round immediately.",
    nr_reshuffle_label: "Reshuffle cards",
    nr_reshuffle_hint: "Builds new cards from the same item pool — every player gets a different card automatically.",
    nr_pattern_label: "Pattern for this round",
    nr_pattern_hint: "Changes the pattern players need to complete — visible to players instantly.",
    nr_reset_note: "Drawn items and existing bingo claims are reset for each new round.",
    nr_start_btn: "Start new round",
    cards_reshuffled: "cards reshuffled",
    cancel: "Cancel",
    round_started: "Round", round_label: "ROUND", round_n_started_suffix: "started",
    next_round_failed: "Next round failed.",
    pattern_updated: "Pattern updated", pattern_update_failed: "Pattern update failed.",
    all_items_drawn: "All items have been drawn!", draw_failed: "Draw failed.",
    reset_confirm: "Reset all draws?", reset_done: "Reset!", reset_failed: "Reset failed.",
    enter_valid_card_num: "Enter a valid card number.", not_found: "Not found", update_failed: "Update failed.",
    oops: "Oops", to_home: "To home", loading_dots: "Loading…",
    player_view: "Player view", bingo_pattern: "Bingo pattern", refresh: "Refresh",
    players_count: "players", card_short: "Card", marked_short: "marked",
    valid_bingo_short: "✓ Valid bingo", not_yet_valid: "not valid yet",
    devtools_visible: "🛠️ Dev tools visible", devtools_hidden: "🔒 Dev tools hidden",
    pro_test_activated_short: "Pro test activated", activate_failed: "Activation failed",
    mb_badge: "Music bingo",
    mb_title_a: "Pick your",
    mb_title_b: "music genre.",
    mb_subtitle: "Pick a genre — we automatically fill your cards with 75+ hits including artist and title.",
    mb_songs: "songs",
    mb_create_cta: "Create cards",
    mb_skip_link: "Or pick manually in the generator",
    nav_music_bingo: "Music bingo",
    nav_themes: "Themes",
    nav_number_gen: "Number caller",
    nav_teachers: "For teachers",
    music_sub_hub: "All music bingo",
    music_sub_foute_kerst: "Christmas hits",
    music_sub_foute_bedrijf: "Office party hits",
    music_sub_foute_bruiloft: "Wedding hits",
    music_sub_nederlandstalig: "Dutch hits",
    genre_locked_title: "Selected music genre",
    genre_locked_desc: "Your songs are pre-filled. Click 'Generate' to create your cards.",
    change_genre: "Pick another genre",
    related_genres: "Related genres",
    pro_only_label: "Pro",
    upgrade_to_pro_cta: "Upgrade to Pro",
    playlist_dl_short: "Playlist",
    playlist_dl_btn: "Download playlist",
    playlist_dl_pro_hint: "Playlist download is a PRO feature",
    playlist_dl_title: "Download your Spotify playlist",
    playlist_dl_desc: "Download the full song list and import it into Spotify in one click via a free converter.",
    playlist_dl_txt: "Download .txt",
    playlist_dl_csv: "Download .csv",
    playlist_dl_how_btn: "How to import to Spotify?",
    playlist_import_title: "Add it to your Spotify account in 4 steps",
    playlist_step1: "Download the .txt or .csv file above (1 click).",
    playlist_step2_a: "Open",
    playlist_or: "or",
    playlist_step2_b: "— both free tools that move music between streaming platforms.",
    playlist_step3: "Choose 'Source' → 'File upload' and drop in your downloaded file. Choose 'Destination' → Spotify and log in.",
    playlist_step4: "Click 'Start transfer'. Within 1–2 minutes your playlist is live in Spotify, ready to shuffle for bingo night!",
    playlist_tip: "Tip: TuneMyMusic transfers the first 500 songs for free (plenty for 80–100 bingo songs).",

    // === Pro+ Spotify add-on ===
    proplus_badge: "Pro+ Add-on",

    // 3-options explainer (Free / Pro / Pro+)
    mb_3options_title: "Two ways to play Music Bingo",
    mb_3options_intro: "The music plays right in the app — every drawn song sounds instantly with its album art. No Spotify, account or Premium needed.",
    opt_free_badge: "Free demo",
    opt1_h: "Free demo",
    opt1_sub: "first 10 songs",
    opt1_p: "Try music bingo for free: the first 10 songs play in the app with album art. Hear exactly how your night will sound.",
    opt1_b1: "20 bingo cards free to print",
    opt1_b2: "First 10 songs play with a 30s clip + album art",
    opt1_b3: "No account, Spotify or install needed",
    opt1_b4: "Max 20 cards free with this option!",
    opt2_h: "PRO Presenter mode",
    opt2_sub: "all songs · €9.95",
    opt2_p: "The complete music bingo show: our tool draws songs, plays each 30s clip with big album art, keeps score and validates BINGO.",
    opt2_b1: "Every song plays in the app (30s clip + album art)",
    opt2_b2: "Presenter mode with big screen + QR code to join",
    opt2_b3: "Guess mode: hide the title until the reveal",
    opt2_b4: "Live scoreboard, BINGO validation and unlimited cards",
    opt2_b5: "You present, players cross off on their own card",
    opt2_b6: "Unlimited cards in this mode",
    opt3_h: "PRO+ Spotify integration",
    opt3_sub: "PRO version + €4.99 extra",
    opt3_p: "Play songs straight from the bingo caller — the best experience for any host.",
    opt3_b1: "Build your own playlist or pick a music theme",
    opt3_b2: "Use the bingo caller to “draw” songs and play them directly from the caller",
    opt3_b3: "Online card checker, rounds and pattern play",
    opt3_b4: "Unlimited cards per session",
    opt3_b5: "Best experience as a bingo host",
    opt3_cta: "Activate Pro+ — €4.99 extra",
    opt3_premium_note: "PRO version + Spotify Premium required for this option",
    opt3_addon_note: "On top of Pro €9.95",
    pro_plus_total_explain: "Pro+ is an add-on on top of Pro. Total one-time €14.94 for the full Music Bingo Presenter experience.",
    pdf_footer_text: "Want to play bingo too? www.bingocards-generator.com",
    mb_playlist_download_btn: "Download playlist",
    mb_howto_btn: "How it works",

    // /music-bingo intro paragraph (first content after hero)
    mb_intro_h: "What is Music Bingo?",
    mb_intro_p1: "Music Bingo is the ultimate party game where players listen for songs and artists instead of looking for numbers. Each player gets a unique card with 9, 16 or 25 squares filled with artists + titles from a chosen genre — from 80s classics to guilty pleasure singalongs. When a song plays, players cross off the matching square. First to a row or full house shouts BINGO!",
    mb_intro_p2: "Below you'll find 14 pre-filled music genres with 75+ hits per genre — ready to print or play online. Further down you'll see three ways to set up your night: free with Spotify shuffle, with our Pro presenter tool, or with the full Pro+ Spotify integration where the generator auto-plays every song.",

    // Homepage Pro+ tier teaser
    proplus_landing_h: "Three ways to play Music Bingo",
    proplus_landing_p: "From free Spotify shuffle to a fully integrated Pro+ experience. Pick what suits your night.",
    proplus_tier1_h: "Spotify Shuffle",
    proplus_tier1_p: "Make your own playlist, hit shuffle. Players cross off themselves. No host required.",
    proplus_tier2_h: "PRO Presenter mode",
    proplus_tier2_p: "Our bingo tool draws songs, tracks scores, validates BINGO claims. You play in Spotify.",
    proplus_tier3_h: "PRO+ Spotify integration",
    proplus_tier3_p: "Your Spotify Premium account inside the generator. Click = song plays automatically. Fully hands-free.",
    proplus_tier3_b1: "One click = next song plays",
    proplus_tier3_b2: "No more manual searching",
    proplus_tier3_b3: "Live control (pause, next, previous)",
    proplus_recommended: "Recommended",
    proplus_addon_label: "Add-on",
    proplus_addon_suffix: "on top of Pro",

    proplus_title: "Export your songs to Spotify",
    proplus_subtitle: "Bonus on top of Pro: export your songs to a Spotify playlist in one click. In-app playback already works with Pro.",
    proplus_price_note: "one-time, on top of Pro",
    proplus_features_h: "What do you get extra?",
    proplus_feat_1: "One click: all your songs in a Spotify playlist (in-app playback already works with Pro)",
    proplus_feat_2: "No more manual searching in Spotify per draw — focus on your audience instead",
    proplus_feat_3: "Live control (pause, next, previous) directly from the bingo host page",
    proplus_feat_4: "Works on web + tablet, no extra app needed",
    proplus_premium_h: "For Spotify export (Premium recommended)",
    proplus_premium_p: "Spotify only allows programmatic playback for",
    proplus_checkbox_label: "I understand that a Spotify Premium account (€10.99/month or a free trial) is required to use the Pro+ feature. A free Spotify account will not work.",
    proplus_buy_cta: "Get Pro+ for €4.99",
    proplus_loading: "Loading...",
    proplus_later: "Later",
    proplus_unlock_cta: "Activate Pro+",
    proplus_cta_homepage_h: "Did you know...",
    proplus_cta_homepage_p: "With our Music Bingo you can download the full playlist to Spotify for free. And with Pro+ (€4.99) you can play every draw directly through Spotify — perfect for hosts.",
    proplus_cta_learn_more: "See Music Bingo →",
    proplus_did_you_know: "Did you know?",
    play_next_song: "Play next song",
    host_proplus_h: "Activate Pro+ — export to Spotify",
    host_proplus_p: "Bonus: push your songs to a Spotify playlist in one click. In-app playback already works without Spotify.",
    spotify_connect_h: "Connect your Spotify account",
    spotify_connect_p: "Requires Spotify Premium to play songs.",
    spotify_login_btn: "Login with Spotify",
    spotify_disconnect: "Disconnect",
    spotify_login_first: "Connect your Spotify account first",
    spotify_pause: "Pause",
    spotify_resume: "Resume",
    spotify_skip: "Next",
    spotify_prev: "Previous",
    spotify_playing_on: "Playing on", spotify_this_device: "This computer (caller)", spotify_choose_device: "Choose a device",
    spotify_refresh_devices: "Refresh devices", spotify_no_devices: "No devices found. Open Spotify on the device you want to play on (e.g. the tablet) and click refresh.",
    pro_required_h: "Activate PRO first",
    pro_required_p: "PRO+ is an add-on on top of an active PRO account. Activate PRO first (€9.95) to get unlimited cards, then you can add PRO+ for the Spotify integration.",
    pro_required_buy_pro: "Get PRO first — €9.95", pro_required_buy_pro_short: "Get PRO first",
    pro_required_cancel: "Cancel",
    tier_free_cta: "Start free",
    tier_pro_cta: "Activate PRO",
    tier_proplus_cta: "Activate PRO+Spotify",
    unique_music_h: "UNIQUE Music Bingo mode",
    unique_music_p: "Play with our unique Music Bingo mode — the music plays right in the app with album art on the big screen. Free demo with the first 10 songs; Spotify export is optional.",
    eyecatcher_h: "Now also Music Bingo that plays right in the app",
    eyecatcher_p: "Every drawn song plays instantly with album art on the big screen — no Spotify or account needed. Click here for all options.",
    eyecatcher_cta: "See Music Bingo",
    mb_custom_badge: "Custom list",
    mb_custom_h: "Build your own playlist",
    mb_custom_p: "Add your own artists + songs. Perfect for a birthday or wedding.",
    mb_custom_cta: "Start empty playlist",
    mb_custom_title_suffix: "Custom playlist",
    music_format_hint_h: "Format:",
    music_format_hint_example: "Example:",
    mb_seo_h1: "Music Bingo Maker — the music plays right in the app",
    mb_seo_p1: "Music Bingo is the ultimate party game where players listen for artists and titles instead of numbers. Our free Music Bingo generator creates unique 3×3, 4×4 or 5×5 cards — ideal for birthdays, weddings, office parties and disco nights. Pick one of our 14 pre-filled genres (80s hits, 90s hits, Dutch, German, Rock, Cheesy, Christmas, Disco, Hip-Hop, Schlager, Pop) or build your own playlist with the simple 'Artist | Title' format.",
    mb_seo_p2: "What makes our Music Bingo unique? The music plays right in the app. Every drawn song sounds instantly as a 30s preview with album art on the big screen — no Spotify, account or Premium needed. A free demo covers the first 10 songs; with Pro every song plays.",
    mb_seo_h2_format: "The Artist | Title format",
    mb_seo_format_p: "We use a simple pipe ( | ) format to separate artist and title. On the bingo card the artist appears small and the title large. Examples of valid rows:",
    mb_seo_format_more: "... and so on, up to 80+ songs per playlist",
    mb_seo_h2_spotify: "How does the music play?",
    mb_seo_spotify_p1: "Every drawn song automatically plays a 30-second preview with the album art shown large. It all happens right in the app — no Spotify, account or Premium needed:",
    mb_seo_spotify_b1: "Automatic 30s previews with album art on every draw",
    mb_seo_spotify_b2: "Big album art to cast to a second screen or TV",
    mb_seo_spotify_b3: "Guess mode: hide the title until you reveal it",
    mb_seo_spotify_b4: "Works on laptop, tablet and mobile — no extra app or account needed",
    mb_seo_h2_occasions: "What occasions suit Music Bingo?",
    mb_seo_occasions_p: "Music Bingo is perfect for office parties, bachelor/bachelorette nights, weddings, birthdays, Christmas mixers, school year-end events and disco nights in cafés. Works for groups from 4 to 200+ players — print one card per person and your night becomes legendary.",
    mb_seo_h2_faq: "Frequently asked questions",
    mb_seo_faq1_q: "Do I need a Spotify or Premium account?",
    mb_seo_faq1_a: "No. The music plays right in the app via short previews with album art — no Spotify, account or Premium needed. Free demo for the first 10 songs; Pro plays them all.",
    mb_seo_faq2_q: "How many songs per playlist?",
    mb_seo_faq2_a: "Our 14 pre-filled genres have 75–100 unique songs each. For your own playlist we recommend at least 25 songs (5×5 card). More songs means more variety between cards.",
    mb_seo_faq3_q: "Can I add my own artists + titles?",
    mb_seo_faq3_a: "Yes! Click the 'Build your own playlist' tile and enter your own list using the 'Artist | Title' format (one per line). Perfect for specific birthdays or weddings.",
    mb_seo_faq4_q: "Does it work on mobile and tablet?",
    mb_seo_faq4_a: "Yes. Presenter mode and playback work in any modern browser on laptop, tablet and mobile. You can cast the second screen (with album art and QR code) to a TV or projector.",
    mb_howto_badge: "How it works",
    mb_howto_title: "Make your own Spotify playlist",
    mb_howto_intro: "The bingo cards only show artist + title — no audio. You create your own free Spotify playlist with the same songs, and play it during your bingo night.",
    mb_step1_h: "Open Spotify",
    mb_step1_p: "Open Spotify on your phone, computer or TV. A free account is enough — Premium is not required.",
    mb_step2_h: "Search the songs",
    mb_step2_p: "Search the artist + title from your chosen genre and add them one by one to a new playlist.",
    mb_step3_h: "Play during bingo",
    mb_step3_p: "Hit shuffle — Spotify plays random tracks. Players cross off the artist/title they recognize.",
    mb_option_a_h: "Option A — Spotify shuffle",
    mb_option_a_p: "Easiest: put your playlist on shuffle. When a song plays, all players cross it off. No host needed.",
    mb_option_b_h: "Option B — Presenter mode",
    mb_option_b_p: "For control: use our Bingo Presenter. For each draw, find the song on Spotify and play a short clip — perfect for larger groups.",
    mb_unique_note: "💡 Tip: each artist appears only once per genre — more variety on every card.",
    mb_landing_h1_a: "Music bingo for",
    mb_landing_h1_b: "any party.",
    mb_landing_p: "Pick from 14 music genres — from cheesy hits to 80's classics. We fill your cards automatically with 75+ songs (artist + title).",
    mb_landing_cta: "Browse all genres",
    mb_landing_genres_more: "+ 5 other genres — see all ›",
    themes_section_badge: "Bingo themes",
    themes_section_h_a: "Or pick a",
    themes_section_h_b: "ready-made theme.",
    themes_section_p: "13 themes with 80+ words each — print directly or play online. Click for more info.",
    themes_section_view: "View",
    nav_home: "Home",

    // Homepage SEO content sections (2026-08-16) — targets money keywords
    // per GSC gap analysis: "bingo card generator", "bingo maker", etc.
    seo_intro_h: "What is a bingo card generator?",
    seo_intro_p: "A bingo card generator is an online tool that creates professional, unique printable bingo cards in seconds — with your own text, photos or one of our 15 ready-made themes. No software to install, no design skills needed. Pick your size (3x3, 4x4 or 5x5), fill the card and download a print-ready PDF or play online instantly. Every card is auto-shuffled, so no two players get the same combination. Perfect for schools, kids parties, family gatherings, office parties and music bingo nights.",
    seo_why_h: "Why our bingo card generator?",
    seo_why_p: "Unlike static PDF templates on other sites, our generator creates truly unique cards with smart shuffle algorithms. You get up to 20 cards free, can upload your own images for theme parties, choose from 3 card sizes and print 1, 2, 3 or 4 cards per A4 to save paper. Plus, play online: each participant scans a QR code to get their own bingo card on their phone — no app download. From €9.95 per session you unlock unlimited cards for large groups.",
    seo_who_h: "Who is this bingo maker for?",
    seo_who_school_h: "For schools & teachers",
    seo_who_school_p: "Math bingo, vocabulary bingo, letter bingo or classic Christmas bingo in class — the generator supports text and images. Print 30 unique cards for the whole class in minutes, or play together with the presenter mode on the smart board. Popular with primary and secondary teachers worldwide.",
    seo_who_party_h: "For parties & families",
    seo_who_party_p: "Birthday, Christmas dinner, hen party or baby shower — pick a theme and print the cards. Use your own photos for extra personal cards. Works perfectly as an ice-breaker at weddings with our 'events-bingo' variant.",
    seo_who_business_h: "For businesses & teams",
    seo_who_business_p: "Office Christmas bingo, team-building bingo or meeting bingo. Ideal for corporate events where not everyone knows each other. Print per-team cards or play online during remote drinks. Add branding and logos with the Pro session.",
    seo_how_h: "How does the bingo generator work?",
    seo_how_p: "Three steps: (1) pick a theme or start blank, (2) keep the 80+ pre-filled items or type your own text / upload photos, (3) pick the number of cards and click Generate. You get a print-ready PDF or a unique share-code to play online. Takes literally 30 seconds.",
    seo_trust_stat_1_v: "20",
    seo_trust_stat_1_l: "cards free",
    seo_trust_stat_2_v: "15+",
    seo_trust_stat_2_l: "ready themes",
    seo_trust_stat_3_v: "3",
    seo_trust_stat_3_l: "sizes (3x3, 4x4, 5x5)",
    seo_trust_stat_4_v: "€0",
    seo_trust_stat_4_l: "signup cost, no account",
    // Why-BingoMaker USP block (GEO step 5, 2026-08-17)
    why_badge: "Why bingocards-generator",
    why_bingo_maker_h: "Everything you need for bingo — in one tool",
    why_bingo_maker_p: "The only online bingo generator with AI, in-app music playback, live caller AND scoreboard. For schools, parties, corporate events and music bingo nights.",
    why_feat_ai: "AI bingo generator",
    why_feat_spotify: "In-app music",
    why_feat_music: "Music bingo",
    why_feat_online: "Play online",
    why_feat_caller: "Live bingo caller",
    why_feat_scoreboard: "Live scoreboard",
    why_feat_unique: "Unique bingo cards",
    why_feat_pdf: "PDF download",
    why_feat_mobile: "Mobile play",
    why_feat_i18n: "Dutch / English / German",
    why_feat_groups: "Large-group friendly",

    // Spotify banner — homepage flagship (2026-08-16). Highlights the unique
    // Spotify Web Playback integration (Pro+ tier).
    spotify_banner_h: "Music bingo that plays right in the app — no Spotify or account needed",
    spotify_banner_p: "The bingo caller draws a song AND plays it instantly with album art on the big screen. Free demo with the first 10 songs. Optionally export to Spotify.",
    spotify_feat_1: "Every song plays instantly (30s clip + album art)",
    spotify_feat_2: "Play / pause / skip from the caller",
    spotify_feat_3: "Works with any genre or your own list",
    spotify_feat_4: "Free demo · Pro plays everything",
    spotify_banner_cta: "Make a music bingo",
    spotify_banner_more: "More about Music Bingo",

    // AI Theme Generator (NEW — flagship feature)
    ai_badge: "✨ NEW · AI",
    ai_nav_pill: "✨ AI Generator",
    ai_btn: "✨ AI Bingo Generator",
    ai_btn_short: "✨ AI",
    ai_modal_title: "Describe your theme — AI does the rest",
    ai_modal_subtitle: "Tell us what the bingo is about. Our AI generates up to 80 unique, original bingo items in English in 5 seconds.",
    ai_prompt_label: "What's the theme?",
    ai_prompt_placeholder: "E.g. \"Beach vacation in Greece\" or \"50th wedding anniversary\" or \"First day at a new job\"",
    ai_count_label: "Number of items",
    ai_count_hint: "30 items works perfectly for a 5×5 grid with 10+ players.",
    ai_generate_btn: "✨ Generate bingo items",
    ai_generating: "AI is thinking…",
    autogen_wait: "The AI is putting your bingo cards together…",
    ai_autogen_done: "cards ready — tweak or download right away!",
    sp_pl_title: "Put this bingo on Spotify",
    sp_pl_desc: "Automatically create a playable Spotify playlist from all the songs — share the link with your host.",
    sp_pl_btn: "Create Spotify playlist",
    sp_pl_login_note: "You log in to Spotify once (a free account works too).",
    sp_pl_creating: "Creating playlist…",
    sp_pl_done: "Your Spotify playlist is ready!",
    sp_pl_open: "Open in Spotify",
    sp_pl_copy: "Copy link",
    sp_pl_copied: "Link copied!",
    sp_pl_added: "songs added of",
    sp_pl_notfound: "Not found on Spotify:",
    sp_pl_error: "Creating playlist failed. Please try again.",
    sp_pl_not_registered: "Your Spotify account doesn't have access to this app yet. Please contact the administrator to have your Spotify email added.",
    sp_pl_house_down: "The Spotify connection is temporarily unavailable. Download the song list or try again later.",
    sp_pl_need_songs: "Generate a music bingo with songs first.",
    sp_pl_locked_title: "Create Spotify playlist (PRO+)",
    sp_pl_locked_note: "Automatically creating a real Spotify playlist is a PRO+ feature (Spotify connection). With PRO you can download the song list and import it yourself.",
    sp_pl_locked_cta: "Activate PRO+ Spotify",
    ai_remaining_label: "AI generations today",
    ai_limit_reached: "Daily limit reached. Try again tomorrow or upgrade to PRO.",
    ai_error: "Something went wrong. Try a different theme.",
    ai_success_toast: "AI generated {n} items!",
    ai_apply_btn: "Use these items",
    ai_regenerate_btn: "Regenerate",
    ai_preview_heading: "What the AI came up with",
    ai_title_label: "Suggested title",
    ai_hero_promo: "🤖 Looking for inspiration? Our AI invents 30 unique items from a single sentence.",
    ai_landing_h: "Build bingo with AI",
    ai_landing_p: "Type one sentence (\"Star Wars trivia night\" or \"Sarah's 50th birthday\") and our AI delivers 30 original items in English. Click. Print. Play.",
    ai_landing_cta: "Try AI Generator",
    ai_examples_label: "Looking for inspiration? Try:",
    ai_example_1: "Italian beach vacation",
    ai_example_2: "Office holiday party",
    ai_example_3: "First week of school",
    ai_example_4: "Wedding anniversary",
    ai_prompt_required: "Please enter a theme",
    mb_strip_title: "How do you want to play Music Bingo?",
    mb_strip_compare: "Full comparison",
    mb_strip_free_h: "Free",
    mb_strip_free_p: "20 cards + 10-song demo",
    mb_strip_pro_h: "Pro",
    mb_strip_pro_p: "All songs play + presenter mode",
    mb_strip_proplus_h: "Pro+Spotify",
    mb_strip_proplus_p: "Auto-play from your Spotify Premium",
    mp_badge: "Play on mobile",
    mp_title: "Everyone plays — straight from their phone",
    mp_intro: "No app needed. One share link or QR code and every player gets their own unique card. Tap a square to mark it. The system automatically detects BINGO when five align!",
    mp_step1_badge: "1. Join",
    mp_step1_label: "Scan QR or enter the 4-letter code",
    mp_step2_badge: "2. Play",
    mp_step2_label: "Tap to mark — every player a unique card",
    mp_step3_badge: "3. Win",
    mp_step3_label: "Automatic BINGO detection + Wall of Fame",
    mp_join_kicker: "JOIN",
    mp_scan_or_code: "Scan or enter code",
    mp_or_code: "or code",
    mp_tap_to_mark: "Tap to mark",
    mp_auto_detect: "Five in a row!",
    mp_wall_of_fame: "You're on the Wall of Fame",
    mp_b1_h: "No download needed",
    mp_b1_p: "Works instantly in the browser on every phone (iOS & Android).",
    mp_b2_h: "Unique cards for everyone",
    mp_b2_p: "One share link distributes different cards across all players automatically.",
    mp_b3_h: "Auto BINGO detection",
    mp_b3_p: "The system checks row, column, diagonal or full house for you.",
    mp_real_screens: "Real screenshots",
    mp_real_player_h: "Player view",
    mp_real_player_p: "Every player sees their own unique card. Tap to mark cells or shout BINGO.",
    mp_real_share_h: "Share in one click",
    mp_real_share_p: "QR code, share link and ready-to-go WhatsApp invite. Paste and go.",
    mp_real_host_h: "Host dashboard",
    mp_real_host_p: "Live scoreboard, pattern picker, Spotify integration and BINGO claim validation.",
    mp_real_blurb: "Want to see how it really looks? View the three live screens (player · share · host) in full size.",
    mp_real_open_cta: "View real screenshots",
    proplus_includes_pro: "Includes everything in Pro",
    proplus_music_only: "Music Bingo only",
    email_label: "Your email",
    email_placeholder: "name@example.com",
    email_help: "We'll email you the play link and a (one-time) edit link.",
    email_optional_toggle: "Add email (optional)",
    email_required_paid: "Email is required for a paid session.",
    email_invalid: "Please enter a valid email address.",
    promo_have_code: "Got a promo code?",
    promo_code_label: "Promo code",
    promo_check: "Check",
    promo_invalid: "Code is invalid or already used",
    promo_free_detected: "✓ Free code! Session will unlock without payment.",
    promo_discount_detected: "✓ Discount code valid",
    promo_applied_unlocked: "Session unlocked with promo code!",
    promo_unlock_free: "Unlock for free",
    edit_token_unlocked: "Edit access granted. Tweak your bingo and save again.",
    edit_token_used: "This edit link has already been used.",
    edit_token_invalid: "Edit link is invalid.",
    set_not_found: "Bingo set not found",
    loaded_existing_set: "Bingo loaded",
    call_sheet_subtitle: "Tick off as you play",
    call_sheet_footer: "%d terms — tick them off as you play.",
    call_sheet_button: "Present call sheet",
    ai_music_tip_h: "Tip for Music Bingo",
    ai_music_tip_p1: "Looking for artists and titles? Ask the AI to use the format",
    ai_music_tip_p2: "(e.g. 'Queen | Bohemian Rhapsody'). Each card will show artist AND title clearly — and Spotify will work flawlessly.",
    ai_free_bullet: "AI theme generator (10/day)",
    ai_pro_bullet: "AI theme generator (10/day)",
    ai_proplus_bullet: "AI auto-formats 'Artist | Title' — Spotify works flawlessly",
    tier_proplus_cta_long: "Activate Pro+Spotify",
  },
  de: {
    nav_create: "Erstellen", free_remaining: "gratis übrig", unlocked: "Pro aktiv",
    free_daily_intro: "Gratis: 1 Bingo pro Tag —", free_daily_cards_left: "Karten heute übrig", free_daily_used: "Dein kostenloses Bingo für heute ist verbraucht.", free_next_in: "wieder gratis in ~", hours_short: "Std",
    pw_daily_title: "Kostenloses Bingo heute aufgebraucht", pw_daily_body: "Du bekommst 1 kostenloses Bingo (bis 20 Karten) pro 24 Stunden. Jetzt upgraden für unbegrenzt, oder später wiederkommen —",
    hero_badge: "20 Karten gratis · 15 Themen",
    hero_h1_main: "bingocards-generator",
    hero_h1_sub: "Der komplette Online-Bingo-Generator.",
    hero_subtitle_new: "Bingokarten-Generator mit KI, Musikbingo, Live-Caller & PDF. Für Schulen, Partys & Büros — kostenlos drucken oder online spielen, ohne Account.",
    hero_promise_h1: "Organisiere in 5 Minuten ein komplettes Bingo",
    hero_promise_sub: "Erstelle kostenlos deine Bingokarten, teile sie mit deinen Spielern und spiele direkt online mit.",
    hero_cta_primary: "Kostenlos dein Bingo erstellen",
    hero_cta_secondary: "So funktioniert's",
    hero_trust: "Keine Kreditkarte · kein Account · kostenlos starten",
    hero_benefit_1: "In Minuten fertig",
    hero_benefit_2: "Drucken of online spielen",
    hero_benefit_3: "Für jeden Anlass",
    trust_fact_1: "Kein Account nötig",
    trust_fact_2: "20 Karten gratis",
    trust_fact_3: "Drucken of online spielen",
    trust_fact_4: "NL · EN · DE",
    // ── FASE C: Generator-Schnellstart + "Bingo fertig" Erfolgsmoment ──
    qs_title: "Schnellstart in 3 Schritten",
    qs_dismiss: "Überspringen",
    qs_step1: "Wähle dein Bingo",
    qs_step2: "Für wie viele Spieler?",
    qs_step3: "Erstelle dein Bingo",
    qs_type_words: "Wörter-Bingo", qs_type_words_desc: "Eigene Wörter oder Thema",
    qs_type_music: "Musikbingo", qs_type_music_desc: "Spielt in der App",
    qs_type_numbers: "Zahlenbingo", qs_type_numbers_desc: "Klassisch 1–75 oder 1–90",
    qs_type_ai: "KI erledigt das", qs_type_ai_desc: "Beschreibe dein Thema",
    qs_players_hint: "Meist 1 Karte pro Spieler — später anpassbar.",
    qs_players_custom: "Andere",
    qs_players_unit: "Spieler",
    qs_next: "Weiter", qs_back: "Zurück",
    qs_make: "Mein Bingo erstellen",
    qs_fill_words: "Füge unten deine Wörter hinzu (oder nutze ein Thema), dann erstelle die Karten.",
    ready_title: "Dein Bingo ist fertig!",
    ready_subtitle: "Karten bereit zum Drucken oder Online-Spielen.",
    ready_download: "PDF herunterladen", ready_download_desc: "Zu Hause oder in der Schule drucken",
    ready_online: "Online spielen", ready_online_desc: "Per QR-Code teilen",
    ready_caller: "Live-Caller", ready_caller_desc: "Auf Beamer oder Whiteboard präsentieren",
    ready_upgrade_line: "Online-Spiel & Live-Caller sind in PRO — ab €9,95 pro Sitzung.",
    ready_upgrade_cta: "PRO ansehen",
    ready_locked: "PRO",
    // ── FASE D: ehrliche Zahlungs-Trust + Anwendungsfälle (keine erfundenen Reviews) ──
    pay_trust_1: "Einmalzahlung, kein Abo",
    pay_trust_2: "Sichere Zahlung via iDEAL & Stripe",
    pay_trust_3: "Kein Konto nötig",
    pay_trust_4: "20 Karten gratis zum Testen",
    hero_spotify_badge: "Musik spielt in der App",
    usecases_badge: "Für jeden Anlass",
    usecases_h: "Wofür nutzen Menschen bingocards-generator?",
    usecases_p: "Vom Klassenzimmer bis zur Kneipe — derselbe Generator, unzählige Anlässe.",
    uc_school_h: "Schulen & Klassenzimmer", uc_school_p: "Rechen-, Rechtschreib- oder ESL-Bingo für die ganze Klasse, fertig vor dem Klingeln.",
    uc_party_h: "Kindergeburtstage", uc_party_p: "Themen-Bingo mit eigenen Fotos und Wörtern — der Eisbrecher auf jeder Party.",
    uc_office_h: "Firmen & Teambuilding", uc_office_p: "Kennenlern- und Meeting-Bingo für Team-Events und Betriebsfeiern.",
    uc_wedding_h: "Hochzeiten", uc_wedding_p: "Persönliches Bingo mit Erinnerungen an das Brautpaar für die Gäste.",
    uc_music_h: "Musikabende", uc_music_p: "Musikbingo, das direkt in der App spielt — schräge Weihnacht, 80er/90er und mehr.",
    uc_care_h: "Pflege & Senioren", uc_care_p: "Große, gut lesbare Karten mit Zahlen oder Wörtern für Aktivitäten.",
    tile_ai_h: "KI Themen-Generator", tile_ai_p: "Jedes Thema — druckfertige Karten in 15 Sekunden.",
    tile_music_h: "Musikbingo", tile_music_p: "14 Genres · spielt in der App · 80er, 90er, Hochzeit, Firmenfeier.",
    tile_live_h: "Live-Caller", tile_live_p: "Präsentiere am Beamer oder Smartboard mit Scoreboard.",
    tile_print_h: "PDF & online spielen", tile_print_p: "Zuhause drucken oder per QR-Code aufs Handy teilen.",
    tile_cta: "Öffnen",
    nav_compare: "Vergleich",
    footer_compare: "Vergleich 2026",
    nav_which_today: "Welches Bingo willst du machen?",
    nav_group_popular: "Beliebt",
    nav_group_tools: "Tools",
    nav_group_info: "Info",
    menu_music_spotify: "Musikbingo mit Sound",
    menu_music_spotify_sub: "Songs spielen direkt in der App",
    menu_music_only: "Musikbingo — nur Karten",
    menu_music_only_sub: "14 Genres, drucken oder online spielen",
    menu_number_bingo: "Zahlenbingo 75 / 90",
    menu_number_bingo_sub: "Fertige Zahlenkarten (1-75 & 1-90)",
    menu_ball_drawer: "Bingo-Kugelzieher",
    menu_ball_drawer_sub: "Online-Caller — zieht automatisch die Kugeln",
    menu_theme_bingo: "Themen-Bingo",
    menu_theme_bingo_sub: "Weihnachten, Geburtstag, Hochzeit, Kinder",
    menu_sinterklaas: "Nikolaus-Bingo",
    menu_sinterklaas_sub: "Bilder- & Musikbingo — druckfertig",
    menu_ai_bingo: "KI-generiertes Bingo",
    menu_ai_bingo_sub: "Beschreib dein Event — KI erledigt den Rest",
    menu_custom_bingo: "Eigenes Bingo",
    menu_custom_bingo_sub: "Eigene Wörter oder Fotos hochladen",
    landing_choose_h: "Welches Bingo willst du machen?",
    landing_choose_p: "Wähle deinen Typ — in 30 Sekunden am Spielen. Kostenlos drucken oder online spielen.",
    hero_title_a: "Erstelle", hero_title_b: "Bingokarten", hero_title_c: "die", hero_title_d: "richtig", hero_title_e: "Spaß machen.",
    hero_subtitle: "Ein Bingo-Generator für Lehrer, Eltern & Bingo-Moderatoren. Text oder Bilder, klassisch oder im Bulk. Kein Account nötig.",
    cta_start: "Kostenlos starten", cta_bulk: "Bulk Generator", no_card_needed: "Keine Kreditkarte. Kein Account. Sofort loslegen.",
    features_title: "Ein Tool. Jedes Bingo. Kein Aufwand.",
    features_subtitle: "bingocards-generator ist vollständig KI-basiert, mit scharfer Typografie, 15 fertigen Themen, einer einzigartigen Moderator-Ansicht, einzigartigen Teil-Codes und automatischer Karten-Zuweisung.",
    f1_title: "3x3, 4x4, 5x5", f1_desc: "Alle Größen. Klassisch 5x5 mit FREE-Mitte oder kompakt für Kinder.",
    f2_title: "Text oder Bilder", f2_desc: "Eigene Bilder hochladen oder Text eintippen. Perfekt für Mottopartys & Schulen.",
    f3_title: "15 Themen", f3_desc: "Weihnachten, Halloween, Musik, Ostern, Hochzeit und mehr — sofort einsatzbereit.",
    f4_title: "PDF & Teilen", f4_desc: "Perfekt drucken oder einen Link teilen — jeder Spieler bekommt eine eigene Karte.",
    themes_title: "15 fertige Themen", view_all: "Alle anzeigen",
    how_works: "So funktioniert's", how_intro: "Von der Idee zum Druck<br/>in drei Schritten.",
    how1_t: "Thema wählen", how1_d: "Eines der 15 Themen oder leer starten.",
    how2_t: "Ausfüllen", how2_d: "Tippe Text, lade Bilder oder lass das Thema auto-füllen.",
    how3_t: "Drucken oder teilen", how3_d: "PDF herunterladen oder einen Link teilen — jeder Spieler bekommt eine eigene Karte.",
    prices: "Preise",
    pricing_title: "20 Karten gratis. ab €9,95 pro Session.",
    pricing_subtitle: "Einmalig pro Session. Branding, Moderator-Modus und Teil-Codes nur in bezahlten Sessions. iDEAL & Karte.",
    free_plan: "Gratis", paid_plan: "Pro Session", per_session: "pro Session · einmalig pro Session ab 20 Karten frei",
    always: "Immer gratis", popular: "Beliebt", try_no_account: "Alles ausprobieren, ohne Account.",
    free_f1: "1 gratis Bingo pro Tag (bis 20 Karten)", free_f2: "Alle 15 Themen & Größen", free_f3: "PDF-Download", free_f4: "Text & Bild-Upload",
    locked_f1: "Eigenes Logo & Markenname", locked_f2: "Moderator-Modus (Zahlen ziehen)", locked_f3: "Online Teil-Code", locked_f4: "Auto-Zuweisung pro Spieler",
    pro_f1: "Unbegrenzte Karten in dieser Session", pro_f2: "Alle Themen, Größen, PDF",
    pro_f3: "Eigenes Logo & Markenname", pro_f4: "Moderator-Modus (Ziehung + Bingo-Check)",
    pro_f5: "Online Teil-Code", pro_f6: "Auto-Zuweisung — 1 Link, 100 Spieler, alle unterschiedlich",
    pro_f7: "Eigenes FREE-Wort auf Karten", pro_f8: "Live-Scoreboard mit 'Fast Bingo' Hinweisen",
    pro_f_music1: "Musik-Bingo Moderator-Modus: jeder Song spielt mit großem Albumcover auf dem großen Bildschirm",
    pro_f_music2: "Rate-Modus + QR-Bildschirm, damit Spieler sofort mitmachen",
    cta_make_first: "Erste Karte erstellen",
    builder_title: "Bingo Maker", one_card: "Eine Karte", bulk_gen: "Bulk Generator",
    generator: "Generator",
    items: "Begriffe", ready: "bereit", more_needed: "fehlen noch",
    need_minimum: "Mindestens", items_for_size: "Begriffe für Format", currently_have: "Du hast aktuell",
    min_items_explainer: "Benötigte Anzahl für Format",
    your_card: "DEINE KARTE",
    add_items_first: "Bitte zuerst Begriffe hinzufügen.",
    you_are: "Du spielst als", change: "ändern",
    name_explainer: "Gib deinen Namen ein, um mitzuspielen. Andere sehen dich im Leaderboard, sobald du gewinnst!",
    live_status: "Live-Status",
    psm_title: "Deine Bingokarten sind fertig … und jetzt?",
    psm_subtitle: "Folge diesem 3-Schritte-Plan und alle spielen in wenigen Minuten mit.",
    psm_step: "Schritt",
    psm_your_task: "Deine Aufgabe",
    psm_step1_title: "Teile die Bingokarten mit deinen Spielern",
    psm_step1_task: "QR-Code generieren und zeigen",
    psm_qr_label: "QR-Code — scannen & spielen",
    psm_qr_explainer: "Drucke oder zeige diesen QR-Code, damit Teilnehmer direkt mit ihrem Handy ihre eigene Karte erhalten. Auch ideal in der Einladung.",
    psm_qr_download: "QR-Code herunterladen",
    psm_code_label: "Teil-Code & Link",
    psm_code_explainer: "Füge diesen Code oder Link in deine Einladungs-E-Mail, WhatsApp oder Kalender-Einladung ein. Jeder, der den Link öffnet, erhält automatisch eine eindeutige Karte.",
    psm_step2_title: "Jeder Teilnehmer erhält eine eindeutige Karte",
    psm_step2_explainer: "Beim ersten Öffnen des Links wird automatisch eine der generierten Karten zugewiesen. Bei späteren Besuchen sehen sie immer dieselbe Karte — keine Verwirrung.",
    psm_step3_title: "Drücke 'Präsentieren', um Host zu werden",
    psm_step3_explainer: "Als Bingo-Host öffnet sich der Moderator-Bildschirm. Dort bestimmst du pro Runde das Bingo-Muster, siehst alle Spieler live, validierst Bingo-Ansagen und überprüfst Karten mit einem Blick.",
    psm_have_fun: "Viel Spaß beim Bingo!",
    psm_help: "Klappt etwas nicht?",
    psm_protip_label: "Profi-Tipp",
    psm_copy_invite: "Einladung kopieren (WhatsApp)",
    psm_invite_copied: "Einladung kopiert! In WhatsApp oder E-Mail einfügen.",
    psm_invite_template: "🎉 Bingo-Time! Bist du dabei?\n\nTippe auf den Link, um deine eigene einzigartige Karte zu erhalten — einfach auf dem Handy öffnen.\nVergiss nicht, deinen Namen einzutragen!\n\n👉 Mitspielen: {url}\n\nBis gleich!",
    psm_reopen: "Anleitung erneut anzeigen",
    edit_applied: "Änderung auf gleichem Code gespeichert",
    edits_left_suffix: "Bearbeitung übrig",
    session_consumed: "Session verbraucht. Ein neues Set kostet €9,95.",
    edit_quota_exceeded: "Du hast bereits einmal bearbeitet. Für weitere Änderungen: neue Session.",
    settings: "Karten-Einstellungen", title_label: "Titel", size_label: "Format", free_middle: "FREE Mitte",
    free_word: "FREE-Wort", theme: "Thema", branding: "Branding (nur Pro)", brand_name_label: "Markenname (Untertitel)",
    logo_label: "Logo (PNG/JPG, max 1MB)", logo_size_label: "Logo-Größe", upload: "Hochladen", replace: "Ersetzen", optional: "Optional",
    actions: "Aktionen", shuffle: "Mischen", clear: "Leeren", download_pdf: "PDF herunterladen",
    cards_per_page: "Karten pro Seite",
    bulk_settings: "Bulk-Einstellungen", num_cards: "Anzahl Karten", items_list: "Liste (1 pro Zeile)",
    images_opt: "Bilder (optional)", generate: "Generieren", download: "Download",
    share_title: "Teilen & moderieren (nur Pro)", share_desc: "Speichere deine Karten online mit Teil-Code. Jeder Spieler bekommt automatisch eine andere Karte zugewiesen.",
    save_get_code: "Spielen & präsentieren!", your_code: "Dein Code", copy_link: "Link kopieren",
    view: "Anzeigen", present: "Moderieren", pro_only_lock: "Pro-Funktion",
    editor: "Editor", print_preview: "Druckvorschau", preview: "Vorschau", no_cards_yet: "Noch keine Karten.", fill_and_click: "Liste ausfüllen und klicke",
    preview_one_of: "Karte 1 von",
    preview_one_of_x: "Karte {n} von {total}",
    preview_pdf_match: "So sieht dein PDF aus — 1-zu-1.",
    pick_card: "Karte wählen",
    card: "Karte",
    reshuffle_btn: "Neue Runde, neue Karten",
    reshuffle_hint: "Alle Karten neu generieren mit zufälligen Positionen — gleiche Item-Liste",
    reshuffled_toast: "Neue Karten generiert!",
    cell_help: "Auf eine Zelle klicken zum Tippen. Über 📷 ein Bild hochladen.",
    pro_only_panel: "Verfügbar während einer Pro-Session (€9,95).", pro_active: "Pro aktiv", unlock_pro: "Pro freischalten",
    fill_with: "Füllen mit", content: "Inhalt", busy: "Lädt…",
    fill_with_short: "Thema füllen",
    themes_show: "Andere Themen", themes_hide: "Ausblenden",
    cross_examples_h: "9 KI-Bingo-Beispiele ansehen",
    cross_examples_p: "Geburtstag, Hochzeit, Klassen-Bingo, Büro, JGA und mehr. Ein Klick lädt die Items in den Generator.",
    cross_examples_cta: "Beispiel-Galerie",
    cross_caller_badge: "Bingo Caller",
    cross_caller_h: "Online Bingo-Zahlen ziehen",
    cross_caller_p: "Gratis Bingo-Caller für 1-75 oder 1-90. Direkt im Browser. Auf eigener Seite einbettbar.",
    cross_caller_cta: "Bingo Caller öffnen",
    play_assigned: "Dir wurde automatisch", play_card: "Karte", play_total: "Karten insgesamt",
    your_name: "Dein Name (für Moderator)", call_bingo: "BINGO rufen!", sending: "Senden…",
    valid_bingo: "Bestätigt: deine Karte hat eine gültige Bingo-Linie.", invalid_bingo: "Noch keine gültige Bingo-Linie.",
    claimed_at: "Beansprucht um", presenter_sees: "Der Moderator sieht dich im Scoreboard.",
    host_locked_title: "Moderator-Modus ist Pro",
    host_locked_desc: "Mit einer Pro-Session (€9,95) freischalten, um Zahlen zu ziehen und Bingo zu prüfen.",
    unlock_session: "🎟️ Diese Session freischalten", or_view_player: "Oder eine Karte als Spieler ansehen",
    last_draw: "Letzte Ziehung", click_draw_to_start: "Klick",
    draw_next: "Nächste ziehen", drawing: "Ziehe…", reset: "Reset",
    all_drawn_items: "Alle Items", presenter: "MODERATOR · CODE",
    cards: "Karten", claims: "Claims", drawn: "gezogen",
    view_player_view: "Spieler-Ansicht",
    scoreboard: "Live Scoreboard", bingo_claims: "🎉 Bingo Claims",
    no_claims_yet: "Noch keine Claims. Spieler bekommen einen", almost_bingo: "🔥 Fast Bingo",
    away: "braucht", to_go: "mehr",
    new_claims: "Neue Claims", show: "Zeigen", accept: "Akzept.", reject: "Ablehn.",
    winners: "Gewinner",
    check_card_title: "Karte prüfen",
    bingo: "BINGO", no_bingo: "Kein Bingo", full_house: "Volle Karte", marked_count: "Felder",
    fill_card_num: "Kartennummer eingeben.",
    payment_success_title: "Zahlung erfolgreich!", payment_success_desc: "Dein Account ist freigeschaltet. Erstelle unbegrenzte Karten.",
    back_to_builder: "Weitermachen", payment_polling: "Zahlung wird geprüft…", payment_unknown: "Status unbekannt",
    payment_unknown_desc: "Zahlung noch nicht bestätigt. Bitte später erneut versuchen.",
    back_to_maker: "Zurück zum Maker",
    payment_cancelled: "Zahlung abgebrochen", payment_cancelled_desc: "Kein Problem — versuch's gerne später nochmal.",
    pw_golden: "Goldenes Ticket", pw_unlock_all: "Alles freischalten",
    pw_intro: "Du hast deine", pw_intro_2: "gratis Karten verbraucht.", pw_intro_3: "Wähle dein Paket und schalte mehr Karten frei.",
    pw_intro_more: "Schalte Pro frei, um unbegrenzt Karten zu erstellen, zu drucken und zu teilen.",
    proplus_cta_builder: "Musik-Bingo? Zu Spotify exportieren (Pro+)",
    gate_title: "Nur noch ein Schritt",
    gate_body: "Gib deine E-Mail ein — wir speichern dein Bingo und senden dir einen Link zum Ansehen, Drucken und späteren Bearbeiten.",
    gate_confirm: "Speichern & weiter",
    gate_skip: "Ohne Speichern fortfahren",
    sp_connected_ok: "Spotify verbunden! Du kannst jetzt deine Playlist erstellen.",
    sp_connect_err: "Verbindung mit Spotify fehlgeschlagen. Bitte erneut versuchen oder neu anmelden.",
    proplus_connect_h: "Nur noch ein Schritt: Spotify verbinden",
    proplus_connect_p: "Verknüpfe dein Spotify-Konto, um sofort eine abspielbare Playlist zu erstellen und zu präsentieren.",
    stepper_done: "Fertig",
    step_create: "Erstellen", step_create_sub: "Ausfüllen & erzeugen",
    step_pro: "Pro", step_pro_sub: "Alles freischalten",
    step_save: "Speichern", step_save_sub: "Speichern & Link mailen",
    step_proplus: "Pro+", step_proplus_sub: "Spotify-Upgrade",
    step_spotify: "Spotify", step_spotify_sub: "Konto verbinden",
    step_present: "Präsentieren", step_present_sub: "Bingo starten",
    save_first_to_present: "Speichere dein Bingo zuerst, dann kannst du präsentieren.",
    menu_title: "Was möchtest du tun?",
    menu_call_sheet: "Aufrufliste präsentieren",
    menu_play_present: "Spielen & präsentieren",
    menu_activate_spotify: "Spotify-Integration aktivieren",
    menu_activate_note: "Einmalig 4,99 € — schaltet echte Spotify-Playlists frei.",
    menu_generate_first: "Erstelle zuerst deine Karten.",
    menu_call_sheet_help: "Alle Begriffe/Songs zum Vorlesen.",
    menu_download_help: "Songliste als Datei speichern.",
    menu_demo_btn: "Musik-Bingo testen (gratis)",
    menu_demo_help: "Höre die ersten 10 Songs mit Albumcover — so klingt dein Bingo.",
    missing_clips_title: "Nicht alle Songs gefunden",
    missing_clips_desc: "Für diese Songs konnten wir keinen Clip oder kein Cover finden:",
    missing_clips_hint: "Tipp: Passe Künstler/Titel in deiner Liste an oder ersetze sie beim Präsentieren über 'Clip suchen'.",
    missing_clips_ok: "Verstanden",
    bs_start_title: "Das Musik-Bingo beginnt gleich!",
    bs_start_scan: "Scanne den QR-Code zum Mitspielen",
    bs_joined_label: "Spieler bereit zum Mitspielen",
    bs_joined_one: "Spieler bereit zum Mitspielen",
    menu_spotify_help: "Bonus: Exportiere deine Songs in eine Spotify-Playlist.",
    menu_play_help: "Spiele die Musik direkt in der App ab und präsentiere auf dem großen Bildschirm.",
    menu_activate_spotify_short: "Spotify aktivieren",
    cs_title: "Aufrufliste",
    cs_items: "Begriffe",
    cs_tab_list: "Liste",
    cs_tab_caller: "Aufrufer-Modus",
    cs_copy: "Alle Begriffe kopieren",
    cs_copied: "Kopiert",
    cs_copy_toast: "Alle Begriffe in die Zwischenablage kopiert",
    cs_copy_fail: "Kopieren fehlgeschlagen — bitte manuell auswählen",
    cs_board: "Vollbild",
    cs_board_title: "Vollbild (für Whiteboard)",
    cs_fs_unsupported: "Vollbild nicht unterstützt",
    cs_print: "Drucken",
    cs_close: "Schließen",
    cs_list_desc_a: "Diese Begriffe sind in zufälliger Reihenfolge — perfekt zum Vorlesen während des Bingos. Klicke",
    cs_list_desc_b: ", um sie in Word, PowerPoint oder deine Whiteboard-App einzufügen.",
    cs_current: "Aktueller Aufruf",
    cs_ready: "Bereit zum Start",
    cs_of: "von",
    cs_called: "aufgerufen",
    cs_togo: "übrig",
    cs_all_called: "Alle Begriffe aufgerufen",
    cs_start: "Start (Leertaste)",
    cs_next: "Weiter (Leertaste)",
    cs_reset: "Zurücksetzen",
    cs_recent: "Zuletzt aufgerufen",
    cs_tip: "Tipp: Klicke 'Vollbild' für dein Whiteboard. Im Aufrufer-Modus drückst du die Leertaste für den nächsten Begriff.",
    proplus_connect_btn: "Mit Spotify verbinden",
    pw_b1: "Unbegrenzte Karten diese Session", pw_b2: "Branding (Logo + Markenname)",
    pw_b3: "Moderator-Modus + Scoreboard", pw_b4: "Eigene Bilder & Themen",
    pw_pay: "Mit iDEAL / Karte zahlen", pw_later: "Vielleicht später",
    restore_cta: "Schon bezahlt? Kauf wiederherstellen",
    restore_email_label: "E-Mail-Adresse, mit der du bezahlt hast",
    restore_email_ph: "du@beispiel.de",
    restore_btn: "Wiederherstellen",
    restore_hint: "Wir verknüpfen deine frühere Zahlung mit diesem Gerät.",
    restore_ok: "Kauf wiederhergestellt! Dein Pro-Zugang ist auf diesem Gerät wieder aktiv.",
    restore_none: "Kein bezahlter Kauf für diese E-Mail-Adresse gefunden.",
    restore_invalid: "Bitte gib eine gültige E-Mail-Adresse ein.",
    restore_fail: "Wiederherstellung fehlgeschlagen. Bitte später erneut versuchen.",
    ps_paid_h: "Zahlung erfolgreich!",
    ps_paid_p: "Dein Konto ist freigeschaltet. Erstelle jetzt deine Bingokarten.",
    ps_continue: "Weiter erstellen",
    ps_checking_h: "Zahlung wird geprüft…",
    ps_checking_p: "Einen Moment, wir bestätigen deine Zahlung.",
    ps_unknown_h: "Status unbekannt",
    ps_unknown_p: "Wir konnten deine Zahlung noch nicht bestätigen. Schau später vorbei oder versuche es erneut.",
    ps_back: "Zurück zum Editor",
    upsell_h: "Machst du ein Musik-Bingo?",
    upsell_p: "Möchtest du Spotify einbinden, damit die Musik sofort im Spiel abgespielt wird?",
    upsell_note: "*Erfordert ein Spotify-Premium-Konto.",
    upsell_btn: "Ja, Spotify hinzufügen (+4,99 €)",
    from_price: "ab", tier_upto: "Bis zu", tier_cards: "Karten", tier_unlimited: "Unbegrenzte Karten",
    tier_per_session: "Einmalig pro Session", tier_popular: "Am beliebtesten", tier_you_pay: "Du zahlst",
    pw_secure: "Sichere Zahlung über Stripe. iDEAL, Kreditkarte und mehr.",
    eenmalig: "einmalig",
    on: "AN", off: "AUS", default_title: "Mein Bingo", optional_placeholder: "Optional",
    save_failed: "Speichern fehlgeschlagen.", saved_code: "Gespeichert! Code:", link_copied: "Link kopiert!",
    cells_first: "Zuerst Zellen ausfüllen.", choose_theme_first: "Erst ein Thema mit Inhalt wählen.",
    loaded: "geladen!",
    number_bingo: "Zahlen-Bingo", number_bingo_desc: "Klassisches Bingo mit Zahlen 1–75 oder 1–90 (ohne Thema). 5x5 Raster mit FREE.",
    generate_n_cards: "Generieren", num_to: "1 bis", make_or_generate_first: "Erst Karten erstellen oder generieren.",
    free_left_msg: "Du hast noch", free_left_left: "gratis Karten übrig.", numbers_generated: "Zahlen-Bingo-Karten (1-",
    cards_generated: "Karten generiert!", pro_test_active: "Pro Test aktiv", pro_deactivate: "Deaktivieren",
    pro_deactivate_confirm: "Pro deaktivieren? Du erhältst eine neue Client-ID mit 20 gratis Karten.",
    confirm_click_again: "Nochmal klicken",
    activate_pro_test: "🧪 Pro-Test aktivieren", pro_test_activated: "🧪 Pro-Test-Session aktiviert — alle Features freigeschaltet!",
    pro_test_failed: "Test-Session konnte nicht aktiviert werden.",
    pdf_failed: "PDF konnte nicht erstellt werden.", generate_first: "Erst Karten generieren.",
    cards_count: "Karten", pdf_downloaded: "Karten heruntergeladen!",
    pro_highlight_title: "Pro macht es richtig groß",
    pro_highlight_subtitle: "Einmalig €9,95 pro Session. Alle Features auf einmal, für dein ganzes Event.",
    pro_cta: "Pro aktivieren",
    view_demo: "Demo-Scoreboard ansehen",
    next_round: "Nächste Runde", next_round_confirm: "Nächste Runde starten? Muster kannst du danach wählen. Gezogene Items bleiben.",
    next_round_hint: "Optionen für die nächste Runde öffnen: Muster wählen und Karten neu mischen",
    next_round_title: "Nächste Runde starten",
    next_round_desc: "Wähle ein Muster und mische optional die Karten neu. Spieler sehen die neue Runde sofort.",
    nr_reshuffle_label: "Karten neu mischen",
    nr_reshuffle_hint: "Erstellt neue Karten aus derselben Item-Liste — jeder Spieler erhält automatisch eine andere Karte.",
    nr_pattern_label: "Muster für diese Runde",
    nr_pattern_hint: "Ändert das Muster, das Spieler erfüllen müssen — sofort sichtbar.",
    nr_reset_note: "Gezogene Items und bestehende Bingo-Ansprüche werden bei jeder neuen Runde zurückgesetzt.",
    nr_start_btn: "Neue Runde starten",
    cards_reshuffled: "Karten neu gemischt",
    cancel: "Abbrechen",
    round_started: "Runde", round_label: "RUNDE", round_n_started_suffix: "gestartet",
    next_round_failed: "Nächste Runde fehlgeschlagen.",
    pattern_updated: "Muster aktualisiert", pattern_update_failed: "Musteraktualisierung fehlgeschlagen.",
    all_items_drawn: "Alle Items wurden bereits gezogen!", draw_failed: "Ziehen fehlgeschlagen.",
    reset_confirm: "Alle Ziehungen zurücksetzen?", reset_done: "Reset!", reset_failed: "Reset fehlgeschlagen.",
    enter_valid_card_num: "Gültige Kartennummer eingeben.", not_found: "Nicht gefunden", update_failed: "Update fehlgeschlagen.",
    oops: "Hoppla", to_home: "Zur Startseite", loading_dots: "Lädt…",
    player_view: "Spieler-Ansicht", bingo_pattern: "Bingo-Muster", refresh: "Aktualisieren",
    players_count: "Spieler", card_short: "Karte", marked_short: "angekreuzt",
    valid_bingo_short: "✓ Gültiges Bingo", not_yet_valid: "noch nicht gültig",
    devtools_visible: "🛠️ Dev-Tools sichtbar", devtools_hidden: "🔒 Dev-Tools versteckt",
    pro_test_activated_short: "Pro-Test aktiviert", activate_failed: "Aktivierung fehlgeschlagen",
    mb_badge: "Musik-Bingo",
    mb_title_a: "Wähle dein",
    mb_title_b: "Musikgenre.",
    mb_subtitle: "Wähle ein Genre — wir füllen deine Karten automatisch mit 75+ Hits inkl. Künstler und Titel.",
    mb_songs: "Songs",
    mb_create_cta: "Karten erstellen",
    mb_skip_link: "Oder manuell im Generator wählen",
    nav_music_bingo: "Musik-Bingo",
    nav_themes: "Themen",
    nav_number_gen: "Zahlengenerator",
    nav_teachers: "Für Lehrer",
    music_sub_hub: "Alle Musikbingo",
    music_sub_foute_kerst: "Weihnachtshits",
    music_sub_foute_bedrijf: "Firmenfeier Hits",
    music_sub_foute_bruiloft: "Hochzeits-Hits",
    music_sub_nederlandstalig: "Deutsche Hits",
    genre_locked_title: "Ausgewähltes Musikgenre",
    genre_locked_desc: "Deine Songs sind bereits geladen. Klicke auf 'Generieren' um deine Karten zu erstellen.",
    change_genre: "Anderes Genre wählen",
    related_genres: "Verwandte Genres",
    pro_only_label: "Pro",
    upgrade_to_pro_cta: "Auf Pro upgraden",
    playlist_dl_short: "Playlist",
    playlist_dl_btn: "Playlist herunterladen",
    playlist_dl_pro_hint: "Playlist-Download ist eine PRO-Funktion",
    playlist_dl_title: "Lade deine Spotify-Playlist herunter",
    playlist_dl_desc: "Lade die komplette Songliste herunter und importiere sie mit 1 Klick in Spotify über einen kostenlosen Converter.",
    playlist_dl_txt: ".txt herunterladen",
    playlist_dl_csv: ".csv herunterladen",
    playlist_dl_how_btn: "Wie in Spotify importieren?",
    playlist_import_title: "In 4 Schritten in deinem Spotify-Account",
    playlist_step1: "Lade die .txt- oder .csv-Datei oben herunter (1 Klick).",
    playlist_step2_a: "Öffne",
    playlist_or: "oder",
    playlist_step2_b: "— beide kostenlose Tools zum Übertragen von Musik zwischen Streaming-Diensten.",
    playlist_step3: "Wähle bei 'Quelle' → 'Datei hochladen' und ziehe deine Datei hinein. Wähle bei 'Ziel' → Spotify und logge dich ein.",
    playlist_step4: "Klicke auf 'Übertragung starten'. Innerhalb von 1–2 Minuten steht deine Playlist in Spotify bereit für den Bingo-Abend!",
    playlist_tip: "Tipp: TuneMyMusic überträgt die ersten 500 Songs kostenlos (mehr als genug für 80–100 Bingo-Titel).",

    // === Pro+ Spotify Add-on ===
    proplus_badge: "Pro+ Add-on",

    // 3-Optionen Erklärung (Frei / Pro / Pro+)
    mb_3options_title: "Zwei Arten, Musik-Bingo zu spielen",
    mb_3options_intro: "Die Musik spielt direkt in der App — jeder gezogene Song erklingt sofort mit Albumcover. Kein Spotify, Konto oder Premium nötig.",
    opt_free_badge: "Gratis-Demo",
    opt1_h: "Gratis-Demo",
    opt1_sub: "erste 10 Songs",
    opt1_p: "Teste Musik-Bingo gratis: Die ersten 10 Songs spielen in der App mit Albumcover. So hörst du genau, wie dein Abend klingt.",
    opt1_b1: "20 Bingokarten gratis zum Drucken",
    opt1_b2: "Erste 10 Songs spielen mit 30s-Clip + Albumcover",
    opt1_b3: "Kein Konto, Spotify oder Installation nötig",
    opt1_b4: "Max. 20 Karten gratis mit dieser Option!",
    opt2_h: "PRO Moderator-Modus",
    opt2_sub: "alle Songs · 9,95 €",
    opt2_p: "Die komplette Musik-Bingo-Show: Unser Tool zieht Songs, spielt jeden 30s-Clip mit großem Albumcover, zählt Punkte und prüft BINGO.",
    opt2_b1: "Jeder Song spielt in der App (30s-Clip + Albumcover)",
    opt2_b2: "Moderator-Modus mit großem Bildschirm + QR-Code zum Mitmachen",
    opt2_b3: "Rate-Modus: Titel bis zur Enthüllung verbergen",
    opt2_b4: "Live-Scoreboard, BINGO-Prüfung und unbegrenzte Karten",
    opt2_b5: "Du moderierst, Spieler streichen auf ihrer Karte ab",
    opt2_b6: "Unbegrenzte Karten in diesem Modus",
    opt3_h: "PRO+ Spotify-Integration",
    opt3_sub: "PRO-Version + 4,99 € extra",
    opt3_p: "Spiele Songs direkt aus dem Bingo-Caller — die beste Erfahrung als Host.",
    opt3_b1: "Erstelle deine eigene Playlist oder wähle ein Musikthema",
    opt3_b2: "Nutze den Bingo-Caller zum „Ziehen“ der Songs und spiele sie direkt aus dem Caller",
    opt3_b3: "Online-Kartenprüfer, Runden festlegen und Muster spielen",
    opt3_b4: "Unbegrenzte Karten pro Sitzung",
    opt3_b5: "Beste Erfahrung als Bingo-Host",
    opt3_cta: "Pro+ aktivieren — 4,99 € extra",
    opt3_premium_note: "PRO-Version + Spotify Premium für diese Option erforderlich",
    opt3_addon_note: "Zusätzlich zu Pro 9,95 €",
    pro_plus_total_explain: "Pro+ ist ein Add-on zusätzlich zu Pro. Insgesamt einmalig 14,94 € für das volle Musik-Bingo Moderator-Erlebnis.",
    pdf_footer_text: "Auch Bingo spielen? www.bingocards-generator.com",
    mb_playlist_download_btn: "Playlist herunterladen",
    mb_howto_btn: "So funktioniert's",

    // /music-bingo Intro-Paragraph (erster Text nach Hero)
    mb_intro_h: "Was ist Musik-Bingo?",
    mb_intro_p1: "Musik-Bingo ist das ultimative Partyspiel, bei dem Spieler statt Zahlen auf Songs und Künstler hören. Jeder Spieler bekommt eine einzigartige Karte mit 9, 16 oder 25 Feldern voller Künstler + Titel aus einem gewählten Genre — von 80er-Klassikern bis zu Schlager-Mitsing-Hits. Wenn ein Song läuft, streichen Spieler das passende Feld ab. Wer zuerst eine Reihe oder volle Karte hat, ruft BINGO!",
    mb_intro_p2: "Unten findest du 14 vorausgefüllte Musikgenres mit 75+ Hits pro Genre — direkt zum Drucken oder online zu spielen. Weiter unten siehst du drei Möglichkeiten, deinen Abend zu gestalten: kostenlos mit Spotify-Shuffle, mit unserem Pro-Moderator-Tool oder mit der vollen Pro+ Spotify-Integration, bei der der Generator jeden Song automatisch abspielt.",

    // Homepage Pro+ Tier-Teaser
    proplus_landing_h: "Drei Arten, Musik-Bingo zu spielen",
    proplus_landing_p: "Vom kostenlosen Spotify-Shuffle bis zur voll integrierten Pro+ Erfahrung. Wähle was zu deinem Abend passt.",
    proplus_tier1_h: "Spotify-Shuffle",
    proplus_tier1_p: "Erstelle deine eigene Playlist, drücke Shuffle. Spieler streichen selbst ab. Kein Moderator nötig.",
    proplus_tier2_h: "PRO Moderator-Modus",
    proplus_tier2_p: "Unser Bingo-Tool zieht Songs, verfolgt Punkte, prüft BINGO-Ansprüche. Du spielst in Spotify ab.",
    proplus_tier3_h: "PRO+ Spotify-Integration",
    proplus_tier3_p: "Dein Spotify Premium-Konto im Generator. Klick = Song spielt automatisch ab. Komplett hands-free.",
    proplus_tier3_b1: "Ein Klick = nächster Song spielt ab",
    proplus_tier3_b2: "Kein manuelles Suchen mehr",
    proplus_tier3_b3: "Live-Steuerung (Pause, Weiter, Zurück)",
    proplus_recommended: "Empfohlen",
    proplus_addon_label: "Add-on",
    proplus_addon_suffix: "zusätzlich zu Pro",

    proplus_title: "Exportiere deine Songs zu Spotify",
    proplus_subtitle: "Bonus zusätzlich zu Pro: Exportiere deine Songs mit einem Klick in eine Spotify-Playlist. Das Abspielen in der App funktioniert bereits mit Pro.",
    proplus_price_note: "einmalig, zusätzlich zu Pro",
    proplus_features_h: "Was bekommst du zusätzlich?",
    proplus_feat_1: "Ein Klick: alle Songs in einer Spotify-Playlist (das Abspielen in der App funktioniert bereits mit Pro)",
    proplus_feat_2: "Kein manuelles Suchen in Spotify mehr pro Ziehung — fokussiere dich auf dein Publikum",
    proplus_feat_3: "Live-Steuerung (Pause, Weiter, Zurück) direkt aus der Bingo-Host-Seite",
    proplus_feat_4: "Funktioniert auf Web + Tablet, keine zusätzliche App nötig",
    proplus_premium_h: "Für Spotify-Export (Premium empfohlen)",
    proplus_premium_p: "Spotify erlaubt programmatische Wiedergabe nur für",
    proplus_checkbox_label: "Ich verstehe, dass ein Spotify Premium-Account (10,99 €/Monat oder eine kostenlose Probezeit) erforderlich ist, um die Pro+ Funktion zu nutzen. Ein kostenloser Spotify-Account funktioniert nicht.",
    proplus_buy_cta: "Pro+ für 4,99 € kaufen",
    proplus_loading: "Lade...",
    proplus_later: "Später",
    proplus_unlock_cta: "Pro+ aktivieren",
    proplus_cta_homepage_h: "Wusstest du schon...",
    proplus_cta_homepage_p: "Mit unserem Musik-Bingo lädst du die komplette Playlist kostenlos zu Spotify herunter. Und mit Pro+ (4,99 €) wird jede Ziehung direkt in Spotify abgespielt — perfekt für Moderatoren.",
    proplus_cta_learn_more: "Zum Musik-Bingo →",
    proplus_did_you_know: "Wusstest du?",
    play_next_song: "Nächsten Song abspielen",
    host_proplus_h: "Pro+ aktivieren — zu Spotify exportieren",
    host_proplus_p: "Bonus: Songs mit einem Klick in eine Spotify-Playlist. Das Abspielen in der App funktioniert bereits ohne Spotify.",
    spotify_connect_h: "Verbinde dein Spotify-Konto",
    spotify_connect_p: "Spotify Premium erforderlich zum Abspielen.",
    spotify_login_btn: "Bei Spotify anmelden",
    spotify_disconnect: "Trennen",
    spotify_login_first: "Verbinde zuerst dein Spotify-Konto",
    spotify_pause: "Pause",
    spotify_resume: "Weiter",
    spotify_skip: "Nächster",
    spotify_prev: "Zurück",
    spotify_playing_on: "Wiedergabe auf", spotify_this_device: "Dieser Computer (Caller)", spotify_choose_device: "Gerät wählen",
    spotify_refresh_devices: "Geräte aktualisieren", spotify_no_devices: "Keine Geräte gefunden. Öffne Spotify auf dem gewünschten Gerät (z. B. dem Tablet) und klicke auf Aktualisieren.",
    pro_required_h: "Zuerst PRO aktivieren",
    pro_required_p: "PRO+ ist ein Add-on zusätzlich zu einem aktiven PRO-Account. Aktiviere zuerst PRO (9,95 €) für unbegrenzte Karten, danach kannst du PRO+ für die Spotify-Integration dazu kaufen.",
    pro_required_buy_pro: "PRO zuerst kaufen — 9,95 €", pro_required_buy_pro_short: "PRO zuerst kaufen",
    pro_required_cancel: "Abbrechen",
    tier_free_cta: "Kostenlos starten",
    tier_pro_cta: "PRO aktivieren",
    tier_proplus_cta: "PRO+Spotify aktivieren",
    unique_music_h: "EINZIGARTIGER Musik-Bingo-Modus",
    unique_music_p: "Spiele mit unserem einzigartigen Musik-Bingo-Modus — die Musik spielt direkt in der App mit Albumcover auf dem großen Bildschirm. Gratis-Demo mit den ersten 10 Songs; Spotify-Export ist optional.",
    eyecatcher_h: "Jetzt auch Musik-Bingo, das direkt in der App spielt",
    eyecatcher_p: "Jeder gezogene Song spielt sofort mit Albumcover auf dem großen Bildschirm — kein Spotify oder Konto nötig. Klicke hier für alle Optionen.",
    eyecatcher_cta: "Zum Musik-Bingo",
    mb_custom_badge: "Eigene Liste",
    mb_custom_h: "Erstelle deine eigene Playlist",
    mb_custom_p: "Füge eigene Künstler + Songs hinzu. Perfekt für Geburtstag oder Hochzeit.",
    mb_custom_cta: "Leere Playlist starten",
    mb_custom_title_suffix: "Eigene Playlist",
    music_format_hint_h: "Format:",
    music_format_hint_example: "Beispiel:",
    mb_seo_h1: "Musik-Bingo erstellen — die Musik spielt direkt in der App",
    mb_seo_p1: "Musik-Bingo ist das ultimative Partyspiel, bei dem Spieler statt Zahlen auf Künstler und Titel hören. Unser kostenloser Musik-Bingo Generator erstellt einzigartige 3×3-, 4×4- oder 5×5-Karten — ideal für Geburtstage, Hochzeiten, Firmenfeiern und Disco-Abende. Wähle aus unseren 14 vorausgefüllten Genres (80er, 90er, Niederländisch, Deutsch, Rock, Schlager, Weihnachten, Disco, Hip-Hop, Pop) oder erstelle deine eigene Playlist mit dem einfachen 'Künstler | Titel'-Format.",
    mb_seo_p2: "Was macht unser Musik-Bingo einzigartig? Die Musik spielt direkt in der App. Jeder gezogene Song erklingt sofort als 30s-Vorschau mit Albumcover auf dem großen Bildschirm — kein Spotify, Konto oder Premium nötig. Eine Gratis-Demo umfasst die ersten 10 Songs; mit Pro spielt jeder Song.",
    mb_seo_h2_format: "Das Künstler | Titel-Format",
    mb_seo_format_p: "Wir verwenden ein einfaches Pipe ( | ) Format, um Künstler und Titel zu trennen. Auf der Bingo-Karte erscheint der Künstler klein und der Titel groß. Beispiele für gültige Zeilen:",
    mb_seo_format_more: "... und so weiter, bis zu 80+ Songs pro Playlist",
    mb_seo_h2_spotify: "Wie spielt die Musik ab?",
    mb_seo_spotify_p1: "Jeder gezogene Song spielt automatisch eine 30-Sekunden-Vorschau mit großem Albumcover ab. Alles passiert direkt in der App — kein Spotify, Konto oder Premium nötig:",
    mb_seo_spotify_b1: "Automatische 30s-Vorschauen mit Albumcover bei jeder Ziehung",
    mb_seo_spotify_b2: "Großes Albumcover zum Casten auf einen zweiten Bildschirm oder TV",
    mb_seo_spotify_b3: "Rate-Modus: Titel verbergen, bis du ihn enthüllst",
    mb_seo_spotify_b4: "Funktioniert auf Laptop, Tablet und Handy — keine extra App oder Konto nötig",
    mb_seo_h2_occasions: "Für welche Anlässe?",
    mb_seo_occasions_p: "Musik-Bingo ist perfekt für Firmenfeiern, Junggesellenabschiede, Hochzeiten, Geburtstage, Weihnachtsfeiern, Schul-Abschlussfeste und Disco-Abende in Cafés. Funktioniert für Gruppen von 4 bis 200+ Spielern — drucke eine Karte pro Person und dein Abend wird legendär.",
    mb_seo_h2_faq: "Häufig gestellte Fragen",
    mb_seo_faq1_q: "Brauche ich ein Spotify- oder Premium-Konto?",
    mb_seo_faq1_a: "Nein. Die Musik spielt direkt in der App über kurze Vorschauen mit Albumcover — kein Spotify, Konto oder Premium nötig. Gratis-Demo für die ersten 10 Songs; mit Pro spielen alle.",
    mb_seo_faq2_q: "Wie viele Songs pro Playlist?",
    mb_seo_faq2_a: "Unsere 14 vorausgefüllten Genres haben jeweils 75–100 einzigartige Songs. Für eine eigene Playlist empfehlen wir mindestens 25 Songs (5×5-Karte). Mehr Songs = mehr Vielfalt zwischen den Karten.",
    mb_seo_faq3_q: "Kann ich eigene Künstler + Titel hinzufügen?",
    mb_seo_faq3_a: "Ja! Klicke auf die 'Eigene Playlist erstellen'-Kachel und gib deine eigene Liste im 'Künstler | Titel'-Format ein (eine pro Zeile). Perfekt für spezielle Geburtstage oder Hochzeiten.",
    mb_seo_faq4_q: "Funktioniert es auch auf Handy und Tablet?",
    mb_seo_faq4_a: "Ja. Moderator-Modus und Wiedergabe laufen in jedem modernen Browser auf Laptop, Tablet und Handy. Du kannst den zweiten Bildschirm (mit Albumcover und QR-Code) auf einen TV oder Beamer casten.",
    mb_howto_badge: "So funktioniert's",
    mb_howto_title: "Erstelle deine eigene Spotify-Playlist",
    mb_howto_intro: "Auf den Bingokarten stehen nur Künstler + Titel — kein Audio. Du erstellst selbst eine kostenlose Spotify-Playlist mit denselben Songs und spielst sie beim Bingo ab.",
    mb_step1_h: "Spotify öffnen",
    mb_step1_p: "Öffne Spotify auf Handy, Computer oder TV. Ein kostenloser Account reicht — Premium ist nicht nötig.",
    mb_step2_h: "Songs suchen",
    mb_step2_p: "Suche Künstler + Titel deines Genres und füge sie nacheinander einer neuen Playlist hinzu.",
    mb_step3_h: "Während Bingo abspielen",
    mb_step3_p: "Drück Shuffle — Spotify spielt zufällig. Spieler streichen die Songs ab, die sie erkennen.",
    mb_option_a_h: "Option A — Spotify-Shuffle",
    mb_option_a_p: "Am einfachsten: Playlist auf Shuffle. Beim Song streichen alle Spieler ab. Kein Spielleiter nötig.",
    mb_option_b_h: "Option B — Präsentator-Modus",
    mb_option_b_p: "Für mehr Kontrolle: nutze unseren Bingo-Präsentator. Bei jeder Ziehung suchst du den Song auf Spotify und spielst ihn kurz — ideal für größere Gruppen.",
    mb_unique_note: "💡 Tipp: Jeder Künstler kommt nur einmal pro Genre vor — mehr Vielfalt auf jeder Karte.",
    mb_landing_h1_a: "Musik-Bingo für",
    mb_landing_h1_b: "jede Party.",
    mb_landing_p: "Wähle aus 14 Musikgenres — von Schlager bis 80er-Hits. Wir füllen deine Karten automatisch mit 75+ Songs (Künstler + Titel).",
    mb_landing_cta: "Alle Genres ansehen",
    mb_landing_genres_more: "+ 5 weitere Genres — alle ansehen ›",
    themes_section_badge: "Bingo-Themen",
    themes_section_h_a: "Oder wähle ein",
    themes_section_h_b: "fertiges Thema.",
    themes_section_p: "13 Themen mit jeweils 80+ Wörtern — sofort drucken oder online spielen. Klick für mehr Infos.",
    themes_section_view: "Ansehen",
    nav_home: "Startseite",

    // Homepage SEO content sections (2026-08-16) — targets money keywords
    // per GSC gap analysis: "Bingokarten Generator", "Bingo erstellen", etc.
    seo_intro_h: "Was ist ein Bingokarten Generator?",
    seo_intro_p: "Ein Bingokarten Generator ist ein Online-Tool, das in Sekunden professionelle, einzigartige druckbare Bingokarten erstellt — mit eigenem Text, Fotos oder einem unserer 15 fertigen Themen. Keine Software zum Installieren, keine Design-Kenntnisse nötig. Wähle die Größe (3x3, 4x4 oder 5x5), fülle die Karte und lade eine druckfertige PDF herunter oder spiele sofort online. Jede Karte wird automatisch gemischt — keine zwei Spieler bekommen dieselbe Kombination. Perfekt für Schulen, Kindergeburtstage, Familienfeiern, Firmenfeiern und Musikbingo-Abende.",
    seo_why_h: "Warum unser Bingokarten Generator?",
    seo_why_p: "Anders als statische PDF-Vorlagen auf anderen Seiten erstellt unser Generator wirklich einzigartige Karten mit smarten Shuffle-Algorithmen. Du bekommst bis zu 20 Karten gratis, kannst eigene Bilder für Themenpartys hochladen, hast die Wahl zwischen 3 Kartengrößen und druckst 1, 2, 3 oder 4 Karten pro A4 um Papier zu sparen. Außerdem: online spielen — jeder Teilnehmer scannt einen QR-Code und bekommt seine eigene Bingokarte aufs Handy, keine App-Installation. Ab 9,95 € pro Sitzung schaltest du unbegrenzt Karten für große Gruppen frei.",
    seo_who_h: "Für wen ist dieser Bingo-Maker?",
    seo_who_school_h: "Für Schulen & Lehrer",
    seo_who_school_p: "Rechenbingo, Sprachbingo, Buchstabenbingo oder klassisches Weihnachtsbingo im Klassenzimmer — der Generator unterstützt Text und Bilder. Druck in wenigen Minuten 30 einzigartige Karten für die ganze Klasse, oder spiel gemeinsam mit dem Präsentator-Modus am digitalen Whiteboard. Beliebt bei Grundschul- und Sekundarstufen-Lehrern.",
    seo_who_party_h: "Für Partys & Familie",
    seo_who_party_p: "Geburtstag, Weihnachtsessen, JGA oder Babyparty — wähl ein Thema und druck die Karten. Nutz eigene Fotos für extra persönliche Karten. Perfekt als Eisbrecher bei Hochzeiten mit unserer 'Ereignis-Bingo'-Variante.",
    seo_who_business_h: "Für Unternehmen & Teams",
    seo_who_business_p: "Firmen-Weihnachtsbingo, Teambuilding-Bingo oder Meeting-Bingo. Ideal für Firmenveranstaltungen, wo nicht alle sich kennen. Druck Karten pro Team oder spiel online während Remote-Drinks. Füg Branding und Logos hinzu mit der Pro-Sitzung.",
    seo_how_h: "Wie funktioniert der Bingo-Generator?",
    seo_how_p: "Drei Schritte: (1) wähl ein Thema oder starte leer, (2) behalte die 80+ vorgefüllten Items oder tipp eigenen Text / lade Fotos hoch, (3) wähl die Kartenanzahl und klick auf Generieren. Du bekommst eine druckfertige PDF oder einen einzigartigen Teil-Code zum Online-Spielen. Dauert buchstäblich 30 Sekunden.",
    seo_trust_stat_1_v: "20",
    seo_trust_stat_1_l: "Karten kostenlos",
    seo_trust_stat_2_v: "15+",
    seo_trust_stat_2_l: "fertige Themen",
    seo_trust_stat_3_v: "3",
    seo_trust_stat_3_l: "Größen (3x3, 4x4, 5x5)",
    seo_trust_stat_4_v: "€0",
    seo_trust_stat_4_l: "Anmeldekosten, kein Account",
    // Why-BingoMaker USP block (GEO step 5, 2026-08-17)
    why_badge: "Warum bingocards-generator",
    why_bingo_maker_h: "Alles was du für Bingo brauchst — in einem Tool",
    why_bingo_maker_p: "Der einzige Online-Bingo-Generator mit KI, Musik direkt in der App, Live-Caller UND Scoreboard. Für Schulen, Partys, Firmenveranstaltungen und Musikbingo-Abende.",
    why_feat_ai: "KI-Bingo-Generator",
    why_feat_spotify: "Musik in der App",
    why_feat_music: "Musikbingo",
    why_feat_online: "Online spielen",
    why_feat_caller: "Live-Bingo-Caller",
    why_feat_scoreboard: "Live-Scoreboard",
    why_feat_unique: "Einzigartige Bingokarten",
    why_feat_pdf: "PDF-Download",
    why_feat_mobile: "Mobile Wiedergabe",
    why_feat_i18n: "Niederländisch / Englisch / Deutsch",
    why_feat_groups: "Für große Gruppen geeignet",

    // Spotify banner — homepage flagship (2026-08-16). Highlights the unique
    // Spotify Web Playback integration (Pro+ tier).
    spotify_banner_h: "Musik-Bingo, das direkt in der App spielt — kein Spotify oder Konto nötig",
    spotify_banner_p: "Der Bingo-Caller zieht einen Song UND spielt ihn sofort mit Albumcover auf dem großen Bildschirm. Gratis-Demo mit den ersten 10 Songs. Optional zu Spotify exportieren.",
    spotify_feat_1: "Jeder Song spielt sofort (30s-Clip + Albumcover)",
    spotify_feat_2: "Play / Pause / Skip aus dem Caller",
    spotify_feat_3: "Funktioniert mit jedem Genre oder eigener Liste",
    spotify_feat_4: "Gratis-Demo · Pro spielt alles ab",
    spotify_banner_cta: "Musik-Bingo erstellen",
    spotify_banner_more: "Mehr über Musikbingo",

    // AI Theme Generator (NEW — flagship feature)
    ai_badge: "✨ NEU · KI",
    ai_nav_pill: "✨ KI Generator",
    ai_btn: "✨ KI Bingo Generator",
    ai_btn_short: "✨ KI",
    ai_modal_title: "Beschreibe dein Thema — die KI erledigt den Rest",
    ai_modal_subtitle: "Sag uns, worum es beim Bingo gehen soll. Unsere KI generiert in 5 Sekunden bis zu 80 einzigartige Bingo-Items auf Deutsch.",
    ai_prompt_label: "Was ist das Thema?",
    ai_prompt_placeholder: "Z.B. \"Strandurlaub in Griechenland\" oder \"50. Hochzeitstag\" oder \"Erster Schultag Klasse 3\"",
    ai_count_label: "Anzahl Items",
    ai_count_hint: "30 Items sind perfekt für ein 5×5 Raster mit 10+ Spielern.",
    ai_generate_btn: "✨ Bingo-Items generieren",
    ai_generating: "KI denkt nach…",
    autogen_wait: "Die KI stellt deine Bingokarten zusammen…",
    ai_autogen_done: "Karten fertig — anpassen oder direkt herunterladen!",
    sp_pl_title: "Dieses Bingo auf Spotify bringen",
    sp_pl_desc: "Erstelle automatisch eine abspielbare Spotify-Playlist aus allen Songs — teile den Link mit deinem Host.",
    sp_pl_btn: "Spotify-Playlist erstellen",
    sp_pl_login_note: "Du meldest dich einmal bei Spotify an (auch Gratis-Konto funktioniert).",
    sp_pl_creating: "Playlist wird erstellt…",
    sp_pl_done: "Deine Spotify-Playlist ist fertig!",
    sp_pl_open: "In Spotify öffnen",
    sp_pl_copy: "Link kopieren",
    sp_pl_copied: "Link kopiert!",
    sp_pl_added: "Songs hinzugefügt von",
    sp_pl_notfound: "Nicht auf Spotify gefunden:",
    sp_pl_error: "Playlist-Erstellung fehlgeschlagen. Bitte erneut versuchen.",
    sp_pl_not_registered: "Dein Spotify-Konto hat noch keinen Zugriff auf diese App. Bitte kontaktiere den Administrator, damit deine Spotify-E-Mail hinzugefügt wird.",
    sp_pl_house_down: "Die Spotify-Verbindung ist vorübergehend nicht verfügbar. Lade die Songliste herunter oder versuche es später erneut.",
    sp_pl_need_songs: "Erstelle zuerst ein Musikbingo mit Songs.",
    sp_pl_locked_title: "Spotify-Playlist erstellen (PRO+)",
    sp_pl_locked_note: "Das automatische Erstellen einer echten Spotify-Playlist ist eine PRO+ Funktion (Spotify-Verbindung). Mit PRO kannst du die Songliste herunterladen und selbst importieren.",
    sp_pl_locked_cta: "PRO+ Spotify aktivieren",
    ai_remaining_label: "KI-Generierungen heute",
    ai_limit_reached: "Tageslimit erreicht. Morgen erneut versuchen oder auf PRO upgraden.",
    ai_error: "Etwas ist schiefgelaufen. Probiere ein anderes Thema.",
    ai_success_toast: "KI hat {n} Items generiert!",
    ai_apply_btn: "Diese Items verwenden",
    ai_regenerate_btn: "Neu generieren",
    ai_preview_heading: "Was sich die KI ausgedacht hat",
    ai_title_label: "Vorgeschlagener Titel",
    ai_hero_promo: "🤖 Suchst du Inspiration? Unsere KI erfindet 30 einzigartige Items aus einem Satz.",
    ai_landing_h: "Bingo bauen mit KI",
    ai_landing_p: "Tippe einen Satz (\"Oktoberfest 2026\" oder \"Saras 50. Geburtstag\") und unsere KI liefert 30 originelle Items auf Deutsch. Klick. Drucken. Spielen.",
    ai_landing_cta: "KI Generator probieren",
    ai_examples_label: "Suchst du Inspiration? Probiere:",
    ai_example_1: "Strandurlaub Italien",
    ai_example_2: "Büro-Weihnachtsfeier",
    ai_example_3: "Erste Schulwoche",
    ai_example_4: "60. Hochzeitstag",
    ai_prompt_required: "Bitte ein Thema eingeben",
    mb_strip_title: "Wie möchtest du Musik-Bingo spielen?",
    mb_strip_compare: "Voller Vergleich",
    mb_strip_free_h: "Gratis",
    mb_strip_free_p: "20 Karten + 10-Song-Demo",
    mb_strip_pro_h: "Pro",
    mb_strip_pro_p: "Alle Songs + Moderator-Modus",
    mb_strip_proplus_h: "Pro+Spotify",
    mb_strip_proplus_p: "Auto-Play aus deinem Spotify Premium",
    mp_badge: "Mobil spielen",
    mp_title: "Alle spielen mit — direkt vom Smartphone",
    mp_intro: "Keine App nötig. Ein Link oder QR-Code und jeder Spieler bekommt seine eigene einzigartige Karte. Tippen = abstreichen. Das System erkennt BINGO automatisch bei fünf in einer Reihe!",
    mp_step1_badge: "1. Beitreten",
    mp_step1_label: "QR scannen oder 4-Buchstaben-Code eingeben",
    mp_step2_badge: "2. Spielen",
    mp_step2_label: "Tippen zum Abstreichen — jeder eine eigene Karte",
    mp_step3_badge: "3. Gewinnen",
    mp_step3_label: "Automatische BINGO-Erkennung + Wall of Fame",
    mp_join_kicker: "BEITRETEN",
    mp_scan_or_code: "Scannen oder Code eingeben",
    mp_or_code: "oder Code",
    mp_tap_to_mark: "Zum Abstreichen tippen",
    mp_auto_detect: "Fünf in einer Reihe!",
    mp_wall_of_fame: "Du stehst auf der Wall of Fame",
    mp_b1_h: "Kein Download nötig",
    mp_b1_p: "Funktioniert direkt im Browser auf jedem Smartphone (iOS & Android).",
    mp_b2_h: "Einzigartige Karten für alle",
    mp_b2_p: "Ein Link verteilt automatisch unterschiedliche Karten an alle Spieler.",
    mp_b3_h: "Auto BINGO-Erkennung",
    mp_b3_p: "Das System prüft Reihe, Spalte, Diagonale oder volle Karte für dich.",
    mp_real_screens: "Echte Screenshots",
    mp_real_player_h: "Spieler-Ansicht",
    mp_real_player_p: "Jeder Spieler sieht seine eigene Karte. Tippen zum Abstreichen oder BINGO rufen.",
    mp_real_share_h: "1-Klick-Teilen",
    mp_real_share_p: "QR-Code, Teil-Link und fertige WhatsApp-Einladung. Einfügen und los.",
    mp_real_host_h: "Moderator-Dashboard",
    mp_real_host_p: "Live-Scoreboard, Muster wählen, Spotify-Integration und BINGO-Claims prüfen.",
    mp_real_blurb: "Sehen, wie es wirklich aussieht? Schaue die drei Live-Screens (Spieler · Teilen · Moderator) in voller Größe an.",
    mp_real_open_cta: "Echte Screenshots ansehen",
    proplus_includes_pro: "Enthält alles aus Pro",
    proplus_music_only: "Nur für Musik-Bingo",
    email_label: "Deine E-Mail",
    email_placeholder: "name@beispiel.de",
    email_help: "Wir senden dir den Spiel-Link und einen (einmaligen) Bearbeitungs-Link.",
    email_optional_toggle: "E-Mail hinzufügen (optional)",
    email_required_paid: "E-Mail ist für eine bezahlte Session erforderlich.",
    email_invalid: "Bitte eine gültige E-Mail-Adresse eingeben.",
    promo_have_code: "Hast du einen Promo-Code?",
    promo_code_label: "Promo-Code",
    promo_check: "Prüfen",
    promo_invalid: "Code ist ungültig oder bereits verwendet",
    promo_free_detected: "✓ Gratis-Code! Session wird ohne Zahlung freigeschaltet.",
    promo_discount_detected: "✓ Rabattcode gültig",
    promo_applied_unlocked: "Session mit Promo-Code freigeschaltet!",
    promo_unlock_free: "Gratis freischalten",
    edit_token_unlocked: "Bearbeitungsrechte aktiviert. Passe dein Bingo an und speichere erneut.",
    edit_token_used: "Dieser Bearbeitungslink wurde bereits verwendet.",
    edit_token_invalid: "Bearbeitungslink ist ungültig.",
    set_not_found: "Bingo-Set nicht gefunden",
    loaded_existing_set: "Bingo geladen",
    call_sheet_subtitle: "Beim Spielen abhaken",
    call_sheet_footer: "%d Begriffe — beim Spielen abhaken.",
    call_sheet_button: "Rufliste präsentieren",
    ai_music_tip_h: "Tipp für Musik-Bingo",
    ai_music_tip_p1: "Suchst du Künstler und Titel? Bitte die KI um das Format",
    ai_music_tip_p2: "zu verwenden (z.B. 'Queen | Bohemian Rhapsody'). Jede Karte zeigt dann Künstler UND Titel deutlich — und Spotify funktioniert einwandfrei.",
    ai_free_bullet: "KI-Themen-Generator (10/Tag)",
    ai_pro_bullet: "KI-Themen-Generator (10/Tag)",
    ai_proplus_bullet: "KI liefert direkt 'Künstler | Titel' — Spotify funktioniert perfekt",
    tier_proplus_cta_long: "Pro+Spotify aktivieren",
  },
};

const I18nCtx = createContext({ lang: "nl", t: (k) => k, setLang: () => {} });

export function I18nProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    // 1) Honor ?lang= query param for SEO/alternate hreflang URLs
    if (typeof window !== "undefined") {
      const q = new URLSearchParams(window.location.search).get("lang");
      if (q && ["nl","en","de"].includes(q)) return q;
    }
    // 2) Explicit prior choice wins
    const saved = typeof localStorage !== "undefined" && localStorage.getItem("bingo_lang");
    if (saved && ["nl","en","de"].includes(saved)) return saved;
    // 3) First launch (e.g. Android app install): adopt the device language
    if (typeof navigator !== "undefined") {
      const langs = navigator.languages && navigator.languages.length ? navigator.languages : [navigator.language];
      for (const l of langs) {
        const code = (l || "").slice(0, 2).toLowerCase();
        if (["nl","en","de"].includes(code)) return code;
      }
    }
    // 4) Default Dutch
    return "nl";
  });
  function setLang(l) {
    localStorage.setItem("bingo_lang", l);
    setLangState(l);
  }
  // Keep <html lang="..."> in sync for SEO and accessibility.
  if (typeof document !== "undefined" && document.documentElement.lang !== lang) {
    document.documentElement.lang = lang;
  }
  function t(key) { return DICT[lang]?.[key] ?? DICT.nl[key] ?? key; }
  return <I18nCtx.Provider value={{ lang, setLang, t }}>{children}</I18nCtx.Provider>;
}
export function useI18n() { return useContext(I18nCtx); }
export const LANGUAGES = [{ id: "en", label: "EN", flag: "🇬🇧" }, { id: "de", label: "DE", flag: "🇩🇪" }, { id: "nl", label: "NL", flag: "🇳🇱" }];
